<template>
  <div id="ag-canvas" style="min-height: 350px;">
    <img
      v-show="this.streamList.length === 0"
      src="../../assets/stage-empty.jpg"
      style="width: 100%;height: 100%"
    />
    <div id="screen-share-panel"></div>
    <button
      style="display: none"
      data-toggle="modal"
      data-target="#showClientModal"
      id="showCientModalButton"
      data-backdrop="static"
      data-keyboard="false"
    ></button>

    <div v-if="!fullscreen" style="position: absolute; right: 0px;top: 0">
      <video
        id="liveVideo"
        style="width: 100%; height: 100%; position: absolute; object-fit: contain;display:none"
        src="https://meetbeans-data.s3.ap-south-1.amazonaws.com/Lockdown/05-0.mp4"
        controls
        crossorigin="anonymous"
      ></video>
      <div style="position: absolute">
        <div
          class="modal fade"
          id="showClientModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="showClientModal"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div
              class="modal-content vue-poll"
              style="background: rgba(0, 0, 0, 0.8)"
            >
              <div class="modal-header">
                <h5 class="modal-title qst" style="color: #ffe">
                  {{ clientPoll.question }}
                </h5>
                <button
                  v-if="visibleResults"
                  id="closeModal"
                  type="button"
                  class="btn btn-danger btn-sm"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  Close
                </button>
              </div>
              <div class="modal-body">
                <div class="ans-cnt">
                  <div
                    v-for="(a, i) in calcAnswers"
                    :key="i"
                    id="clientOptions"
                    class="ans"
                  >
                    <div
                      v-if="!visibleResults"
                      :class="{
                        'ans-no-vote noselect': true,
                        active: a.selected,
                      }"
                      @click.prevent="handleVote(a)"
                    >
                      <span class="txt" v-html="a.text"></span>
                    </div>
                    <div
                      v-else
                      :class="{ 'ans-voted': true, selected: a.selected }"
                    >
                      <span
                        v-if="a.percent"
                        class="percent"
                        v-text="a.percent"
                      ></span>
                      <span class="txt" v-html="a.text"></span>
                    </div>

                    <span
                      class="bg"
                      :style="{ width: visibleResults ? a.percent : '0%' }"
                    ></span>
                  </div>
                </div>
                <div
                  class="votes"
                  v-if="visibleResults"
                  v-text="totalVotesFormatted + ' votes'"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div
          class="modal"
          id="showPollModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="showPollModal"
          aria-hidden="true"
        >
          <div
            class="modal-dialog modal-dialog-centered hostPolls"
            role="document"
          >
            <div
              class="modal-content poll"
              style="background: rgba(0, 0, 0, 0.8)"
            >
              <div class="modal-header">
                <h5 class="modal-title">Polling</h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" class id="poll-close">&times;</span>
                </button>
              </div>
              <div class="modal-body" v-if="polls.length > 0">
                <div v-for="(a, i) in polls" :key="i" class="vue-poll">
                  <!-- <h5 class="qst-2" style="font-weight: bold; color: #ffe">{{ a.question }}</h5> -->
                  <div class="row">
                    <div
                      class="col-md-8 qst"
                      style="font-weight: bold; color: #ffe"
                    >
                      {{ a.question }}
                    </div>
                    <div
                      class="col-md-4 ml-auto"
                      style="font-size: 10px; color: #ffe"
                    >
                      {{ a.created_at | moment("from", "now", true) }}
                    </div>
                  </div>
                  <div class="ans-cnt">
                    <div
                      v-for="(a, i) in calcAnswersForHost(a.answers)"
                      :key="i"
                      id="pollOptions"
                      class="ans"
                    >
                      <div class="ans-voted">
                        <strong
                          ><span
                            v-if="a.percent === '0%'"
                            class="percent"
                            v-text="a.percent"
                            style="color: rgb(218, 51, 51)"
                          ></span
                        ></strong>
                        <!-- <strong><span v-if="a.percent === '0%'"></span></strong> -->
                        <span
                          v-if="a.percent !== '0%'"
                          class="percent"
                          v-text="a.percent"
                        ></span>
                        <strong
                          ><span
                            v-if="a.percent === '0%'"
                            class="txt"
                            v-html="a.text"
                            style="color: rgb(218, 51, 51)"
                          ></span
                        ></strong>
                        <span
                          class="txt"
                          v-if="a.percent !== '0%'"
                          v-html="a.text"
                        ></span>
                      </div>
                      <span
                        class="bg0"
                        v-if="a.percent === '0%'"
                        style=" width: 0.7%"
                      ></span>
                      <span
                        class="bg"
                        v-else
                        :style="{ width: a.percent }"
                      ></span>
                    </div>
                  </div>
                  <!-- <div v-for="(k, i) in a.answers" :key="i">{{ k.text }}</div> -->
                  <hr />
                </div>
              </div>
              <div v-else class="modal-body">
                You have not created any poll yet
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  id="add-poll"
                  class="btn btn-primary"
                  data-dismiss="modal"
                  aria-label="Close"
                  data-toggle="modal"
                  data-target="#addPoll"
                >
                  Add poll
                </button>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  class="btn btn-danger"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div
          class="modal"
          id="addPoll"
          tabindex="-1"
          role="dialog"
          aria-labelledby="addPoll"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div
              class="modal-content poll"
              style="background: rgba(0, 0, 0, 0.8)"
            >
              <div class="modal-header">
                <h5 class="modal-title">Add Poll</h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" class id="poll-close">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label for="question">Question:</label>
                  <input
                    type="text"
                    v-model="poll.question"
                    class="form-control"
                    id="question"
                  />
                </div>
                <div>Options:</div>
                <div class="form-group" v-for="(e, i) in poll.answers" :key="i">
                  <div class="input-group mb-3">
                    <input
                      type="text"
                      class="form-control"
                      v-model="e.text"
                      placeholder="Your option"
                    />

                    <span
                      class="input-group-text btn btn-danger"
                      @click="removeOption(i)"
                    >
                      <i class="fas fa-times"></i>
                    </span>
                  </div>
                </div>
                <button class="btn btn-sm btn-white" @click="addOptions()">
                  <i class="fas fa-plus"></i> Add More
                </button>
              </div>
              <div class="modal-footer">
                <button
                  v-if="poll.question === ''"
                  type="button"
                  id="submit-channel-name"
                  class="btn btn-primary"
                  @click="handlePoll"
                >
                  Submit
                </button>
                <button
                  v-else
                  type="button"
                  id="submit-channel-name"
                  class="btn btn-primary"
                  @click="handlePoll"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  Submit
                </button>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  class="btn btn-danger"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="liveRecordingTimer"
        class="btn-group"
        role="group"
        style="z-index: 100;position: absolute;top: 13px;right: 154px;"
      >
        <!--        <button-->
        <!--          type="button"-->
        <!--          class="btn btn-dark btn-sm"-->
        <!--          style="font-size: 12px;padding: 1px 5px;margin: 0 auto"-->
        <!--        >-->
        <!--          <i class="fa fa-circle blink" aria-hidden="true"></i>-->
        <!--        </button>-->
        <!-- <div class="d-flex" style="z-index: 999999;align-items: center">
        <div class="audio-indicator common-audio-indicator">
        </div>
        <div class="audio-indicator main-audio-indicator">
        </div>
        <div class="audio-indicator common-audio-indicator">
        </div>
      </div> -->
        <button
          type="button"
          class="btn btn-light btn-sm"
          style="font-size: 15px;padding: 1px 10px;"
        >
          <span id="timer">00:00:00</span>
        </button>
      </div>
      <div
        class="btn-group"
        role="group"
        style="z-index: 100;position: absolute;top: 13px;right: 54px;"
      >
        <button
          type="button"
          class="btn btn-danger btn-sm"
          style="font-size: 15px;padding: 1px 10px;"
          @click="pauseVideo"
        >
          LIVE
        </button>
        <button
          type="button"
          class="btn btn-light btn-sm"
          style="font-size: 15px;padding: 1px 10px;"
        >
          {{ this.$store.state.attendeeCount }}
        </button>
      </div>
      <button
        class="btn btn-light btn-sm"
        style="z-index: 100;position: absolute;top: 13px;right: 8px;font-size: 15px;padding: 1px 10px;cursor: pointer;"
        @click="toggleFullScreen"
        title="Full Screen"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="16"
          height="16"
          viewBox="0 0 172 172"
          style=" fill:#000000;"
        >
          <g
            fill="none"
            fill-rule="nonzero"
            stroke="none"
            stroke-width="1"
            stroke-linecap="butt"
            stroke-linejoin="miter"
            stroke-miterlimit="10"
            stroke-dasharray
            stroke-dashoffset="0"
            font-family="none"
            font-weight="none"
            font-size="none"
            text-anchor="none"
            style="mix-blend-mode: normal"
          >
            <path d="M0,172v-172h172v172z" fill="none" />
            <g fill="#ffffff">
              <path
                d="M21.5,21.5v43h14.33333v-28.66667h28.66667v-14.33333zM107.5,21.5v14.33333h28.66667v28.66667h14.33333v-43zM21.5,107.5v43h43v-14.33333h-28.66667v-28.66667zM136.16667,107.5v28.66667h-28.66667v14.33333h43v-43z"
              />
            </g>
          </g>
        </svg>
      </button>

      <div
        style="z-index: 100;position: absolute;top: 47px;right: 8px;font-size: 23px;cursor: pointer;background: rgba(10, 10, 10, 0.75); border-radius: 6px"
      >
        <div
          v-if="networkStatus === '4g'"
          id="strongNetworkIcon"
          title="Strong connection"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="32"
            height="32"
            viewBox="0 0 172 172"
            style=" fill:#000000;"
          >
            <g
              fill="none"
              fill-rule="nonzero"
              stroke="none"
              stroke-width="1"
              stroke-linecap="butt"
              stroke-linejoin="miter"
              stroke-miterlimit="10"
              stroke-dasharray
              stroke-dashoffset="0"
              font-family="none"
              font-weight="none"
              font-size="none"
              text-anchor="none"
              style="mix-blend-mode: normal"
            >
              <path d="M0,172v-172h172v172z" fill="none" />
              <g fill="#2ecc71">
                <path
                  d="M112.875,21.5v129h32.25v-129zM69.875,59.125v91.375h32.25v-91.375zM26.875,96.75v53.75h32.25v-53.75z"
                />
              </g>
            </g>
          </svg>
        </div>
        <div v-else-if="networkStatus === '3g'" title="Bad connection">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="32"
            height="32"
            viewBox="0 0 172 172"
            style=" fill:#000000;"
          >
            <g
              fill="none"
              fill-rule="nonzero"
              stroke="none"
              stroke-width="1"
              stroke-linecap="butt"
              stroke-linejoin="miter"
              stroke-miterlimit="10"
              stroke-dasharray
              stroke-dashoffset="0"
              font-family="none"
              font-weight="none"
              font-size="none"
              text-anchor="none"
              style="mix-blend-mode: normal"
            >
              <path d="M0,172v-172h172v172z" fill="none" />
              <g fill="#f1c40f">
                <path
                  d="M112.875,21.5v129h32.25v-129zM123.625,32.25h10.75v107.5h-10.75zM69.875,59.125v91.375h32.25v-91.375zM26.875,96.75v53.75h32.25v-53.75z"
                />
              </g>
            </g>
          </svg>
        </div>
        <div
          v-else-if="networkStatus === '2g' || networkStatus === 'slow-2g'"
          title="Poor connection"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="32"
            height="32"
            viewBox="0 0 172 172"
            style=" fill:#000000;"
          >
            <g
              fill="none"
              fill-rule="nonzero"
              stroke="none"
              stroke-width="1"
              stroke-linecap="butt"
              stroke-linejoin="miter"
              stroke-miterlimit="10"
              stroke-dasharray
              stroke-dashoffset="0"
              font-family="none"
              font-weight="none"
              font-size="none"
              text-anchor="none"
              style="mix-blend-mode: normal"
            >
              <path d="M0,172v-172h172v172z" fill="none" />
              <g fill="#f1c40f">
                <path
                  d="M112.875,21.5v129h32.25v-129zM123.625,32.25h10.75v107.5h-10.75zM69.875,59.125v91.375h32.25v-91.375zM80.625,69.875h10.75v69.875h-10.75zM26.875,96.75v53.75h32.25v-53.75z"
                />
              </g>
            </g>
          </svg>
        </div>
      </div>
    </div>
    <div
      v-else-if="fullscreen"
      style="position: absolute;top: 0px; right: 0px;"
    >
      <div style="position: absolute">
        <div
          class="modal"
          id="showClientModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="showClientModal"
          aria-hidden="true"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div
              class="modal-content vue-poll"
              style="background: rgba(0, 0, 0, 0.8)"
            >
              <div class="modal-header">
                <h5 class="modal-title qst" style="color: #ffe">
                  {{ clientPoll.question }}
                </h5>
                <button
                  v-if="visibleResults"
                  type="button"
                  class="btn btn-danger btn-sm"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" class id="poll-close">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="ans-cnt">
                  <div
                    v-for="(a, i) in calcAnswers"
                    :key="i"
                    id="clientOptions"
                    class="ans"
                  >
                    <div
                      v-if="!visibleResults"
                      :class="{
                        'ans-no-vote noselect': true,
                        active: a.selected,
                      }"
                      @click.prevent="handleVote(a)"
                    >
                      <span class="txt" v-html="a.text"></span>
                    </div>
                    <div
                      v-else
                      :class="{ 'ans-voted': true, selected: a.selected }"
                    >
                      <span
                        v-if="a.percent"
                        class="percent"
                        v-text="a.percent"
                      ></span>
                      <span class="txt" v-html="a.text"></span>
                    </div>

                    <span
                      class="bg"
                      :style="{ width: visibleResults ? a.percent : '0%' }"
                    ></span>
                  </div>
                </div>
                <div
                  class="votes"
                  v-if="visibleResults"
                  v-text="totalVotesFormatted + ' votes'"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div
          class="modal"
          id="showPollModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="showPollModal"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div
              class="modal-content poll"
              style="background: rgba(0, 0, 0, 0.8)"
            >
              <div class="modal-header">
                <h5 class="modal-title">Polling</h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" class id="poll-close">&times;</span>
                </button>
              </div>
              <div v-if="polls.length > 0">
                <div v-for="(a, i) in polls" :key="i">
                  <h5>{{ a.question }}</h5>

                  <div
                    v-for="(k, i) in calcAnswers"
                    :key="i"
                    id="clientOptions"
                    class="ans"
                  >
                    <span>{{ k.text }}</span>
                    <!-- <div :class="{ 'ans-voted': true }" >
                            <span class="percent" v-text="a.percent"></span>
                            <span class="txt" v-html="a.text"></span>
                        </div> -->

                    <!-- <span class="bg" :style="{ width: visibleResults ? a.percent : '0%' }"></span> -->
                  </div>
                </div>
              </div>
              <div v-else class="modal-body">
                You have not created any poll yet
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  id="submit-channel-name"
                  class="btn btn-primary"
                  data-dismiss="modal"
                  aria-label="Close"
                  data-toggle="modal"
                  data-target="#addPoll"
                >
                  Add poll
                </button>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  class="btn btn-danger"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div
          class="modal"
          id="addPoll"
          tabindex="-1"
          role="dialog"
          aria-labelledby="addPoll"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div
              class="modal-content poll"
              style="background: rgba(0, 0, 0, 0.8)"
            >
              <div class="modal-header">
                <h5 class="modal-title">Add Poll</h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" class id="poll-close">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label for="question">Question:</label>
                  <input
                    type="text"
                    v-model="poll.question"
                    class="form-control"
                    id="question"
                  />
                </div>
                <div>Options:</div>
                <div class="form-group" v-for="(e, i) in poll.answers" :key="i">
                  <div class="input-group mb-3">
                    <input
                      type="text"
                      class="form-control"
                      v-model="e.text"
                      placeholder="Your option"
                    />

                    <span
                      class="input-group-text btn btn-danger"
                      @click="removeOption(i)"
                    >
                      <i class="fas fa-times"></i>
                    </span>
                  </div>
                </div>
                <button class="btn btn-sm btn-white" @click="addOptions()">
                  <i class="fas fa-plus"></i> Add More
                </button>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  id="submit-channel-name"
                  class="btn btn-primary"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click="handlePoll"
                >
                  Submit
                </button>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  class="btn btn-danger"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="btn-group"
        role="group"
        style="z-index: 100;position: absolute;top: 13px;right: 54px;"
      >
        <button
          type="button"
          class="btn btn-danger btn-sm"
          style="font-size: 15px;padding: 1px 10px;"
        >
          LIVE
        </button>
        <button
          type="button"
          class="btn btn-light btn-sm"
          style="font-size: 15px;padding: 1px 10px;"
        >
          {{ this.$store.state.attendeeCount }}
        </button>
      </div>
      <button
        class="btn btn-light btn-sm"
        style="z-index: 100;position: absolute;top: 13px;right: 8px;font-size: 15px;padding: 1px 10px;cursor: pointer;"
        @click="toggleFullScreen"
        title="Normal Screen"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="16"
          height="16"
          viewBox="0 0 172 172"
          style=" fill:#000000;"
        >
          <g
            fill="none"
            fill-rule="nonzero"
            stroke="none"
            stroke-width="1"
            stroke-linecap="butt"
            stroke-linejoin="miter"
            stroke-miterlimit="10"
            stroke-dasharray
            stroke-dashoffset="0"
            font-family="none"
            font-weight="none"
            font-size="none"
            text-anchor="none"
            style="mix-blend-mode: normal"
          >
            <path d="M0,172v-172h172v172z" fill="none" />
            <g fill="#ffffff">
              <path
                d="M43,10.75v32.25h-32.25v10.75h37.625c2.98145,0 5.375,-2.39355 5.375,-5.375v-37.625zM107.5,10.75v37.625c0,2.60352 1.88965,4.87109 4.49317,5.29102c0.29395,0.04199 0.58789,0.08398 0.88183,0.08398h37.625v-10.75h-32.25v-32.25zM10.75,107.5v10.75h32.25v32.25h10.75v-37.625c0,-2.98145 -2.39355,-5.375 -5.375,-5.375zM112.875,107.5c-2.98145,0 -5.375,2.39355 -5.375,5.375v37.625h10.75v-32.25h32.25v-10.75z"
              />
            </g>
          </g>
        </svg>
        <!-- <i class="fas fa-compress"></i> -->
      </button>
      <div
        style="z-index: 100;position: absolute;top: 47px;right: 8px;font-size: 23px;cursor: pointer;background: rgba(10, 10, 10, 0.75); border-radius: 6px"
      >
        <div
          v-if="networkStatus === '4g'"
          id="strongNetworkIcon"
          title="Strong connection"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="32"
            height="32"
            viewBox="0 0 172 172"
            style=" fill:#000000;"
          >
            <g
              fill="none"
              fill-rule="nonzero"
              stroke="none"
              stroke-width="1"
              stroke-linecap="butt"
              stroke-linejoin="miter"
              stroke-miterlimit="10"
              stroke-dasharray
              stroke-dashoffset="0"
              font-family="none"
              font-weight="none"
              font-size="none"
              text-anchor="none"
              style="mix-blend-mode: normal"
            >
              <path d="M0,172v-172h172v172z" fill="none" />
              <g fill="#2ecc71">
                <path
                  d="M112.875,21.5v129h32.25v-129zM69.875,59.125v91.375h32.25v-91.375zM26.875,96.75v53.75h32.25v-53.75z"
                />
              </g>
            </g>
          </svg>
        </div>
        <div v-else-if="networkStatus === '3g'" title="Bad connection">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="32"
            height="32"
            viewBox="0 0 172 172"
            style=" fill:#000000;"
          >
            <g
              fill="none"
              fill-rule="nonzero"
              stroke="none"
              stroke-width="1"
              stroke-linecap="butt"
              stroke-linejoin="miter"
              stroke-miterlimit="10"
              stroke-dasharray
              stroke-dashoffset="0"
              font-family="none"
              font-weight="none"
              font-size="none"
              text-anchor="none"
              style="mix-blend-mode: normal"
            >
              <path d="M0,172v-172h172v172z" fill="none" />
              <g fill="#f1c40f">
                <path
                  d="M112.875,21.5v129h32.25v-129zM123.625,32.25h10.75v107.5h-10.75zM69.875,59.125v91.375h32.25v-91.375zM26.875,96.75v53.75h32.25v-53.75z"
                />
              </g>
            </g>
          </svg>
        </div>
        <div
          v-else-if="networkStatus === '2g' || networkStatus === 'slow-2g'"
          title="Poor connection"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="32"
            height="32"
            viewBox="0 0 172 172"
            style=" fill:#000000;"
          >
            <g
              fill="none"
              fill-rule="nonzero"
              stroke="none"
              stroke-width="1"
              stroke-linecap="butt"
              stroke-linejoin="miter"
              stroke-miterlimit="10"
              stroke-dasharray
              stroke-dashoffset="0"
              font-family="none"
              font-weight="none"
              font-size="none"
              text-anchor="none"
              style="mix-blend-mode: normal"
            >
              <path d="M0,172v-172h172v172z" fill="none" />
              <g fill="#f1c40f">
                <path
                  d="M112.875,21.5v129h32.25v-129zM123.625,32.25h10.75v107.5h-10.75zM69.875,59.125v91.375h32.25v-91.375zM80.625,69.875h10.75v69.875h-10.75zM26.875,96.75v53.75h32.25v-53.75z"
                />
              </g>
            </g>
          </svg>
        </div>
      </div>
    </div>

    <div class="ag-btn-group">
      <div style="display: flex; justify-content: space-between">
        <div
          v-if="isControl"
          style="display: flex; justify-content: space-between"
        >
          <span
            class="ag-btn videoControlBtn tooltip"
            @click="handleCamera"
            title="Enable/Disable Video"
          >
            <i class="fas fa-video-slash"></i>
            <i class="fas fa-video"></i>
            <span class="tooltiptext">Enable/Disable Camera</span>
          </span>
          <span
            class="ag-btn audioControlBtn tooltip"
            @click="handleMic"
            title="Enable/Disable Audio"
          >
            <i class="fas fa-microphone-slash"></i>
            <i class="fas fa-microphone"></i>
            <span class="tooltiptext">Enable/Disable Microphone</span>
          </span>
          <span
            v-show="this.$store.state.role == 'host'"
            class="ag-btn recordingControlBtn tooltip"
            @click="handleRec"
            title="Start/Stop Recording"
          >
            <i class="fas fa-stop"></i>
            <i class="fas fa-play"></i>
            <span class="tooltiptext">Start/Stop Recording</span>
          </span>
          <div
            class="ag-btn displayModeBtn"
            @click="switchDisplay"
            style="padding: 10px 20px; display: none;"
            :class="{ disabled: streamList.length > 4 }"
            title="Switch Display Mode"
            v-if="attendeeMode === 'host'"
          >
            <div style="display: grid;">
              <i class="fas fa-border-all" style="margin-left: 5px"></i>
              <i style="font-size: 10px" class="text-primary">Layout</i>
            </div>
          </div>
          <div
            class="ag-btn displayModeBtn text-dark bg-danger"
            @click="handleLeave"
            v-if="isShowLeave()"
            style="padding: 10px 20px; "
            title="Leave button"
          >
            <div style="display: grid;">
              <i class="fas fa-phone-slash" style="margin-left: 9px"></i>
              <i style="font-size: 10px" class="text-primary">Leave</i>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="attendeeMode === 'host'"
        v-show="!isScreenBeingSharedByRemote"
        style="display: flex; justify-content: space-between"
      >
        <button
          class="ag-btn btn btn-primary btn-round btn-session"
          @click="breakSession"
          title="Break session"
        >
          Take a break
        </button>
        <button
          class="ag-btn btn btn-outline-danger btn-round btn-session"
          @click="endSession"
          title="End session"
        >
          End Session
        </button>

        <!-- <button
          data-toggle="modal"
          data-target="#feedbackModal"
          class="btn btn-primary"
          id="btn-feedback"
        >
          Feedback
        </button> -->
      </div>
      <div
        v-if="attendeeMode === 'speaker'"
        style="display: flex; justify-content: space-between"
      >
        <div v-if="!isSpeakerLive">
          <button
            class="ag-btn btn btn-primary btn-round btn-session"
            @click="handleSpeakerStream"
            title="Start streaming"
          >
            Start Streaming
          </button>
        </div>
        <div v-else>
          <button
            v-show="!isScreenBeingSharedByRemote"
            class="ag-btn btn btn-outline-danger btn-round btn-session"
            @click="handleSpeakerStream"
            title="Stop Streaming"
          >
            Stop Streaming
          </button>
        </div>
      </div>
      <div style="display: flex; justify-content: space-between; float: right">
        <div
          v-if="attendeeMode === 'audience' && !isScreenBeingSharedByRemote"
          class="ag-btn displayModeBtn"
          title="Hand Raise"
          style="padding: 10px 20px;"
        >
          <div
            @click="handleWithdraw()"
            v-show="isHandRaised"
            style="display: grid;"
          >
            <span v-show="isHandRaised">
              <i
                class="far fa-times-circle text-danger"
                style="margin-left: 12px"
              ></i>
            </span>
            <i style="font-size: 10px; margin-top: -7px" class="text-danger"
              >Withdraw</i
            >
          </div>
          <div
            v-show="!isHandRaised"
            style="display: grid;"
            @click="handleHandRaise()"
          >
            <span v-show="!isHandRaised">
              <i class="far fa-hand-paper" style="margin-left: 12px"></i>
            </span>
            <i style="font-size: 10px; margin-top: -7px" class="text-primary"
              >Raise Hand</i
            >
          </div>
        </div>
        <div
          v-if="attendeeMode === 'audience' && isScreenBeingSharedByRemote"
          class="ag-btn displayModeBtn"
          title="Hand Raise"
          style="padding: 10px 20px;"
        >
          <div style="display: grid;" @click="screenShareHandRaiseError()">
            <span>
              <i class="far fa-hand-paper" style="margin-left: 12px"></i>
            </span>
            <i style="font-size: 10px; margin-top: -7px" class="text-primary"
              >Raise Hand</i
            >
          </div>
        </div>
        <span
          class="ag-btn displayModeBtn reaction-bar"
          title="Reaction"
          style="padding: 10px 20px;"
        >
          <div id="showEmoji"></div>
          <div style="display: grid;">
            <ul class="reaction-list">
              <li>
                <button @click="handleReaction('heart')">
                  <img src="../../assets/heart.svg" alt="heart" />
                  <span>{{ reaction.heart }}</span>
                </button>
              </li>
              <li>
                <button @click="handleReaction('clap')">
                  <img src="../../assets/clap.svg" alt="Clap" />
                  <span>{{ reaction.clap }}</span>
                </button>
              </li>
              <li>
                <button @click="handleReaction('thumb')">
                  <img src="../../assets/thumb.svg" alt="Thumb" />
                  <span>{{ reaction.thumb }}</span>
                </button>
              </li>
              <li>
                <button @click="handleReaction('laugh')">
                  <img src="../../assets/laugh.svg" alt="Laugh" />
                  <span>{{ reaction.laugh }}</span>
                </button>
              </li>
            </ul>

            <i class="fa fa-smile" style="margin-left: 8px"></i>
            <i style="font-size: 10px" class="text-primary">Reaction</i>
          </div>
        </span>
        <div
          v-if="
            attendeeMode === 'host' ||
              this.$store.state.showScreenShareButtonForOthers ||
              this.$store.state.isSpeaker
          "
          class="btn-group dropup"
        >
          <button type="button" class="Rectangle" style="background: #1b1b1b" data-toggle="dropdown">
            <i class="fas fa-ellipsis-v"></i>
          </button>
          <div class="dropdown-menu">
            <button
              class="dropdown-item"
              v-if="
                (attendeeMode === 'host' ||
                  this.$store.state.showScreenShareButtonForOthers ||
                  this.$store.state.isSpeaker) &&
                  !isActiveScreenShare &&
                  isScreenBeingSharedByRemote &&
                  !isSharingExternalVideo
              "
              @click="handleRemoteScreenShare"
            >
              <span style="margin-left: -5px; margin-right: 10px">
                <i class="fas fa-share"></i>
              </span>
              Screen Share
            </button>
            <button
              class="dropdown-item"
              v-if="
                (attendeeMode === 'host' ||
                  this.$store.state.showScreenShareButtonForOthers ||
                  this.$store.state.isSpeaker) &&
                  !isActiveScreenShare &&
                  !isScreenBeingSharedByRemote &&
                  !isSharingExternalVideo
              "
              @click="handleScreenShare"
            >
              <span style="margin-left: -5px; margin-right: 10px">
                <i class="fas fa-share"></i>
              </span>
              Screen Share
            </button>
            <!-- <button
              class="dropdown-item"
              @click="addVideo"
              v-if="attendeeMode === 'host' && !isSharingVideo"
            >
              <span style="margin-left: -5px; margin-right: 10px">
                <i class="fas fa-external-link-alt"></i>
              </span>
              <span>
                Live Video
              </span>
            </button> -->
            <!-- <button
              class="dropdown-item"
              @click="removeVideo"
              v-if="attendeeMode === 'host' && isSharingVideo"
            >
              <span style="margin-left: -5px; margin-right: 10px">
                <i class="fas fa-external-link-alt"></i>
              </span>
              <span>
                Remove Video
              </span>
            </button> -->
            <button
              class="dropdown-item"
              v-if="
                attendeeMode === 'host' &&
                  !isSharingExternalVideo &&
                  !isActiveScreenShare &&
                  !isScreenBeingSharedByRemote
              "
            >
              <span style="margin-left: -5px; margin-right: 10px">
                <i class="fas fa-external-link-alt"></i>
              </span>
              <span data-toggle="modal" data-target="#shareVideoModal">
                Share Video
              </span>
            </button>

            <button
              class="dropdown-item"
              v-else-if="attendeeMode === 'host' && isSharingExternalVideo"
              @click="removeInjectedVideo"
              style="color: #ed2f28"
            >
              <span style="margin-left: -5px; margin-right: 10px">
                <i class="fas fa-minus-circle"></i>
              </span>
              Remove Video
            </button>

            <button
              v-if="attendeeMode === 'host'"
              @click="addNewPoll"
              data-toggle="modal"
              data-target="#showPollModal"
              class="dropdown-item"
            >
              <span style="margin-left: -5px; margin-right: 12px">
                <i class="fas fa-poll-h"></i>
              </span>
              Poll
            </button>
          </div>
        </div>
        <span
          class="ag-btn disableRemoteBtn"
          :class="{
            disabled: streamList.length > 4 || displayMode !== 'pip',
          }"
          @click="hideRemote"
          style="display: none"
          title="Hide Remote Stream"
        >
          <i class="fas fa-eye-slash" style="margin-left: 9px"></i>
        </span>
      </div>
    </div>
    <div v-if="isActiveScreenShare" class="text-center">
      <div class="screenShare-presenting">
        <div class="presenting-heading">
          <h4 style="">You are presenting...</h4>
          <button
            v-if="
              (attendeeMode === 'host' ||
                this.$store.state.showScreenShareButtonForOthers ||
                this.$store.state.isSpeaker) &&
                isActiveScreenShare
            "
            class="btn btn-outline-danger"
            style="width: 140px;height: 50px;"
            @click="handleStopScreenShare"
          >
            Stop share
          </button>
        </div>
      </div>

      <div
        id="panel"
        style="
          position: absolute;
          top: 48px;
          right: 0;
          z-index: 10;
          background: #000;
          width: 160px;
          display: flex;
          flex-direction: column;
        "
      ></div>
      <div
        id="userVideos"
        style="width: 100px; z-index: 100;position: absolute;
          top: 48px;
          right: 0; display: none"
      >
        Hello
      </div>
    </div>

    <div
      class="modal"
      id="shareVideoModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="shareVideoModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <h5 class="modal-title" style="display: inline-block">
              Enter Link of the video
            </h5>
            <button
              type="button"
              class="close float-right"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <div style="margin: 20px 0" class="form-group">
              <input
                type="text"
                v-model="shareVideoUrl.url"
                class="form-control"
                placeholder="Enter URL"
              />
            </div>

            <button
              v-if="shareVideoUrl.url === ''"
              class="btn btn-outline-primary pull-right"
              disabled
            >
              Submit
            </button>

            <button
              v-else
              class="btn btn-outline-primary pull-right"
              @click="injectVideo"
              data-dismiss="modal"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isScreenShareLoaded && !isActiveScreenShare" class="text-center">
      <div
        style="
          position: absolute;
          top: 0;
          left: 0;
          z-index: 10;
          background: #000;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        "
      >
        <div
          style="position: absolute;top: 50%;left: 50%;transform: translate(-70%, -50%);text-align: center;"
        >
          <img src="../../assets/loader.gif" width="70" height="70" />
          <p>Loading..</p>
        </div>
      </div>
    </div>
    <!-- <video
      id="localVideo"
      autoplay
      muted
      playsinline
      controls="true"
      style="display: none"
    ></video> -->
  </div>
</template>

<script>
import { merge } from "lodash";
import AgoraRTC from "agora-rtc-sdk";
import UAParser from "ua-parser-js";
import jquery from "jquery";
import Timer from "easytimer";
import "intro.js/minified/introjs.min.css";

const introJS = require("intro.js");

var DetectRTC = require("detectrtc");
// import VuePoll from 'vue-poll';
// import { ConnectionState } from 'agora-rtm-sdk';
const parser = new UAParser();
const userAgentInfo = parser.getResult();
var timer = new Timer();
// ES6 Modules or TypeScript
import Swal from "sweetalert2";
// import { auth } from 'firebase';

// Store the particular interval id
let intervalId;
var condition = navigator.onLine ? true : false;
// console.log("Condition: ", condition);
// document.getElementById('offline').style.display = condition ? 'none' : 'block'
window.addEventListener("load", function() {
  function updateOnlineStatus() {
    condition = navigator.onLine ? true : false;
    // console.log("ConditionInside: ", condition);
    if (condition === true) {
      document.getElementById("offline").style.display = "none";
    } else {
      document.getElementById("offline").style.display = "block";
    }
  }
  window.addEventListener("online", updateOnlineStatus);
  window.addEventListener("offline", updateOnlineStatus);
});
export default {
  data() {
    return {
      isScreenShare: false,
      hiddenUid: "",
      connectionCounter: 0,
      user: {
        name: "",
      },
      client: {},
      screenShareClient: {},
      shareVideoClient: {},
      isScreenBeingSharedByRemote: false,
      isHandRaised: false,
      senderRaisedHandStatus: "",
      localStream: {},
      shareVideoStream: {},
      screenShareStream: "",
      isScreenShareLoaded: false,
      shareUid: null,
      shareVIdeoToken: null,
      displayMode: "tile",
      streamList: [],
      readyState: false,
      facebookStreamUrl: "rtmps://live-api-s.facebook.com:443/rtmp",
      youtubeStreamUrl: "rtmp://a.rtmp.youtube.com/live2",
      mode: "live",
      codec: "vp8",
      appID: "69ef6e3390ff4e32b01d68cf54610419",
      channel: "test",
      uid: null,
      token: "",
      screenShareToken: "",
      screenShareUid: "",
      audioFlag: true,
      videoFlag: true,
      leaveFlag: false,
      attendeeMode: "",
      videoProfile: "",
      handRequest: [],
      networkStatus: "",
      config: "",
      fullscreen: false,
      flagContainer: {
        reactionFlag: false,
      },
      isActiveScreenShare: false,
      isConnectedToHost: false,
      channel_name: "",
      videocall_bool: false,
      clr: "",
      isControl: false,
      localStreamUidList: [],
      remoteScreenShareUid: "",
      getQuery: "",
      reaction: {
        laugh: 0,
        thumb: 0,
        heart: 0,
        clap: 0,
      },
      poll: {
        question: "",
        answers: [
          {
            text: "",
            votes: 0,
          },
        ],
        errors: [],
      },
      clientPoll: {
        poll_id: "",
        question: "",
        answers: [
          {
            text: "",
            votes: 0,
          },
        ],
      },
      polls: [],
      resultVotes: {},
      visibleResults: false,
      isSharingExternalVideo: false,
      shareVideoUrl: {
        url: "",
      },
      isSharingVideo: false,
      audioIndicatorInterval: "",
      isSpeakerLive: false,
    };
  },
  created() {
    this.$store.state.showScreenShareButtonForOthers = false;
    window.addEventListener("beforeunload", this.beforeTabClose);
    this.getReactionFunction();
  },
  computed: {
    showScreenShareButtonForOthers() {
      return this.$store.state.showScreenShareButtonForOthers;
    },
    totalVotes() {
      let totalVotes = 0;
      this.clientPoll.answers.filter((a) => {
        if (!isNaN(a.votes) && a.votes > 0) totalVotes += parseInt(a.votes);
      });
      return totalVotes;
    },
    totalVotesFormatted() {
      return this.totalVotes.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    calcAnswers() {
      if (this.totalVotes === 0)
        return this.clientPoll.answers.map((a) => {
          a.percent = "0%";
          return a;
        });
      //Calculate percent
      return this.clientPoll.answers.filter((a) => {
        if (!isNaN(a.votes) && a.votes > 0)
          a.percent =
            Math.round((parseInt(a.votes) / this.totalVotes) * 100) + "%";
        else a.percent = "0%";
        return a;
      });
    },
  },
  methods: {
    stopCamera() {
      let videoElem = document.getElementById("localVideo");

      const stream = videoElem.srcObject;
      const tracks = stream.getTracks();

      tracks.forEach(function(track) {
        track.stop();
      });

      videoElem.srcObject = null;
    },
    handlePoorConnection() {
      if (this.attendeeMode == "host") {
        Swal.fire({
          title: "Are you sure?",
          text: "Would you like to continue on poor connection ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Stop event!",
        }).then((result) => {
          if (result.value) {
            this.endSession();
          }
        });
      } else if (this.attendee === "speaker") {
        Swal.fire({
          title: "Are you sure?",
          text: "Would you like to continue on poor connection ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Leave stage!",
        }).then((result) => {
          if (result.value) {
            if (this.isSpeakerLive) {
              this.streamList.forEach((stream) => {
                console.log("speaker stream: ", stream, this.streamList);
                if (stream.getId() == this.uid) {
                  this.isSpeakerLive = false;
                  this.isControl = false;
                  this.removeStream(this.localStream.getId());
                  this.localStream.stop();
                  this.localStream.close();
                  this.client.unpublish(this.localStream);
                }
              });
            }
          }
        });
      } else {
        Swal.fire({
          title: "Are you sure?",
          text: "Would you like to continue on poor connection ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Leave stage!",
        }).then((result) => {
          if (result.value) {
            let isActive = false;
            this.streamList.forEach((stream) => {
              if (stream.getId() === this.localStream.getId()) {
                isActive = true;
                this.isHandRaised = false;
                this.isControl = false;
              }
            });
            if (isActive) {
              this.localStream.stop();
              this.localStream && this.localStream.close();
              this.client.unpublish(this.localStream);
              this.removeStream(this.localStream.getId());
            }
          }
        });
      }
    },
    screenShareHandRaiseError() {
      this.$toast.open({
        message: "Sorry, you can't interrupt while screen sharing.",
        type: "error",
        position: "top",
        queue: true,
      });
    },
    pauseVideo() {
      console.log(
        "shareVideoStream paused: ",
        this.shareVideoStream.isPlaying()
      );

      // this.shareVideoStream.pause();
      // this.shareVideoStream.stop();
    },
    removeVideo() {
      let $ = this;
      $.isSharingVideo = false;
      if (document.getElementById("liveVideo")) {
        document.getElementById("liveVideo").pause();
      }
      $.removeStream(this.shareVideoStream.getId());
      $.shareVideoStream && $.shareVideoStream.close();
      $.shareVideoClient &&
        $.shareVideoClient.leave(
          () => {
            console.log("Client succeed to leave.");
          },
          () => {
            console.log("Client failed to leave.");
          }
        );
      // $.displayMode = "tile";
    },
    addVideo() {
      const $ = this;
      $.isSharingVideo = true;
      // let video = document.createElement("video")
      // video.src = "https://meetbeans-data.s3.ap-south-1.amazonaws.com/70653798_2400985073303778_6694423940202092437_n.mp4"
      console.log("Beforeeffect...");

      // console.log("Aftereffect...", videoStream);
      // console.log("Aftereffect...", videoStream.getVideoTracks()[0]);

      // const videoDOM = document.createElement("video")
      // videoDOM.setAttribute("id", "liveVideo")
      // videoDOM.src = "../assets/0305aaf7-884d-4677-82f6-8fc77a1cc2e2.webm"
      // const videoStream = videoDOM.captureStream(60);

      let data = {
        channel_id: this.$route.params.session,
      };
      this.$store.dispatch("getEventShareVideoToken", data).then((resp) => {
        if (resp.data.status === "success") {
          // console.log("Call this... vs--: ", resp.data);
          $.shareUid = resp.data.data.uid;
          $.shareVIdeoToken = resp.data.data.rtc_token;
          $.shareVideoClient = AgoraRTC.createClient({
            mode: $.mode,
            codec: $.codec,
          });

          $.shareVideoClient.init($.appID, () => {
            // $.subscribeStreamEvents();
            $.shareVideoClient.setClientRole("host");

            // client join
            $.shareVideoClient.join(
              $.shareVIdeoToken,
              $.channel,
              $.shareUid,
              () => {
                $.shareVideoClient.enableDualStream(
                  () => {
                    // $.uid = uid;

                    // create local stream
                    // $.shareVideoStream = $.streamInit(
                    //   $.shareUid,
                    //   $.attendeeMode,
                    //   $.videoProfile,
                    //   $.config
                    // );
                    const videoDOM = jquery("#liveVideo")[0];
                    const videoStream = videoDOM.captureStream(60);
                    $.shareVideoStream = AgoraRTC.createStream({
                      audio: true,
                      video: true,
                      videoSource: videoStream.getVideoTracks()[0],
                      audioSource: videoStream.getAudioTracks()[0],
                    });

                    $.shareVideoStream.init(
                      () => {
                        // console.log("ShareVideoStream: ", $.shareVideoStream);
                        // console.log(
                        //   "ShareVideoStream: ",
                        //   $.shareVideoStream.getId()
                        // );
                        // console.log(
                        //   "VideoTrack: ",
                        //   $.shareVideoStream.getVideoTrack()
                        // );

                        // $.addStream($.shareVideoStream, true);
                        $.displayMode = "share";
                        $.shareVideoClient.publish(
                          $.shareVideoStream,
                          (err) => {
                            console.log("Publish local stream error: " + err);
                          }
                        );
                        $.$root.$emit("shareVideoStarted", $.shareVideoStream);
                      },
                      (err) => {
                        console.log("getUserMedia failed", err);
                        if (err.info === "Permission denied") {
                          // handle Permission denied case
                        }
                        $.readyState = true;
                      }
                    );
                    console.log("Screen sharing dual stream");
                  },
                  (err) => {
                    console.log("Screen sharing dual stream error: ", err);
                  }
                );
              }
            );
          });
        } else {
          this.$toast.open({
            message: resp.data.data,
            type: "error",
            position: "top",
            queue: true,
          });
        }
      });
    },
    handleRemoteScreenShare() {
      this.$toast.open({
        message:
          "Can't share your screen. Someone else's screen is already being shared",
        type: "error",
        position: "top",
        queue: true,
      });
    },
    canvasLayout() {
      const $ = this;

      let bc = document.querySelector("#ag-canvas");
      bc.setAttribute(
        "style",
        `display:flex; flex-wrap: wrap; flex-direction: row-reverse;overflow: hidden`
      );

      let panel = document.querySelector("#screen-share-panel");
      panel.setAttribute(
        "style",
        `display: flex;flex-direction: column;width: 15%; height: 85vh;  z-index: 11;`
      );

      let length = $.streamList.length;
      if ($.$store.state.isHostHidden) {
        // length--;
      } else {
        $.hiddenUid = "";
      }
      if ($.isScreenBeingSharedByRemote || $.isSharingExternalVideo) {
        $.streamList.forEach((stream) => {
          let width = "";
          let height = "15vh";
          if (stream.getId() === 10000320 || stream.getId() === 666) {
            width = "85%";
            height = "85vh";
          } else if (stream.getId() == $.hiddenUid) {
            width = "0%";
            height = "0vh";
          } else {
            if ($.streamList.length > 6) {
              width = "50%";
            } else {
              width = "100%";
            }
          }
          let label = document.getElementById(`video-info-${stream.getId()}`);
          // console.log("label: ", label);
          if (label !== null) {
            label.style.bottom = "0";
            label.style.height = "25px";
            // label.style.visibility = "hidden";
            label.firstChild.style.fontSize = ".9em";
            if (label.childNodes !== null) {
              label.childNodes[1].style.visibility = "hidden";
            }
          }
          if (document.querySelector(`#ag-item-${stream.getId()}`)) {
            document.querySelector(
              `#ag-item-${stream.getId()}`
            ).style.width = width;
            document.querySelector(
              `#ag-item-${stream.getId()}`
            ).style.height = height;
          }
        });
      } else {
        let panel = document.querySelector("#screen-share-panel");
        panel.setAttribute(
          "style",
          `display:flex; flex-wrap: wrap; width: 100%;height: 85vh;flex-direction: column`
        );
        if (length === 17) {
          $.streamList.forEach((stream, index) => {
            let width = "";
            let height = "";
            if (index > 0) {
              width = "33.2%";
            } else {
              width = "16.6%";
              height = "21.25vh";
            }
            height = "85vh";
            if (stream.getId() == $.hiddenUid) {
              width = "0%";
              height = "0vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.width = "120px";
              label.style.height = "60px";
              // label.style.visibility = "hidden";
              label.firstChild.style.fontSize = "12px";
              if (label.childNodes !== null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 16) {
          $.streamList.forEach((stream) => {
            let width = "25%";
            let height = "21.25vh";
            if (stream.getId() == $.hiddenUid) {
              width = "0%";
              height = "0vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";
              // label.style.visibility = "hidden";
              label.firstChild.style.fontSize = "12px";
              if (label.childNodes !== null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 15) {
          $.streamList.forEach((stream, index) => {
            let width = "20%";
            let height = "";
            if (index == 0) {
              height = "85vh";
            } else if (index > 0 && index < 3) {
              height = "42.5vh";
            } else {
              height = "21.25vh";
            }
            if (stream.getId() == $.hiddenUid) {
              width = "0%";
              height = "0vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";
              // label.style.visibility = "hidden";
              label.firstChild.style.fontSize = "12px";
              if (label.childNodes !== null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 14) {
          $.streamList.forEach((stream, index) => {
            let width = "25%";
            let height = "";
            if (index < 2) {
              height = "42.5vh";
            } else {
              height = "21.25vh";
            }
            if (stream.getId() == $.hiddenUid) {
              width = "0%";
              height = "0vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";
              // label.style.visibility = "hidden";
              label.firstChild.style.fontSize = "12px";
              if (label.childNodes !== null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 13) {
          $.streamList.forEach((stream, index) => {
            let width = "25%";
            let height = "";
            if (index === 0) {
              height = "85vh";
            } else {
              height = "21.25vh";
            }
            if (stream.getId() == $.hiddenUid) {
              width = "0%";
              height = "0vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";
              // label.style.visibility = "hidden";
              label.firstChild.style.fontSize = "12px";
              if (label.childNodes !== null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 12) {
          $.streamList.forEach((stream) => {
            let width = "25%";
            let height = "28.3vh";
            if (stream.getId() == $.hiddenUid) {
              width = "0%";
              height = "0vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";
              // label.style.visibility = "hidden";
              label.firstChild.style.fontSize = "12px";
              if (label.childNodes !== null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 11) {
          $.streamList.forEach((stream, index) => {
            let width = "25%";
            let height = "";
            if (index < 2) {
              height = "42.5vh";
            } else {
              height = "28.3vh";
            }
            if (stream.getId() == $.hiddenUid) {
              width = "0%";
              height = "0vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";
              // label.style.visibility = "hidden";
              label.firstChild.style.fontSize = "12px";
              if (label.childNodes !== null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 10) {
          $.streamList.forEach((stream, index) => {
            let width = "25%";
            let height = "";
            if (index > 0) {
              height = "28.3vh";
            } else {
              height = "85vh";
            }
            if (stream.getId() == $.hiddenUid) {
              width = "0%";
              height = "0vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";
              // label.style.visibility = "hidden";
              label.firstChild.style.fontSize = "12px";
              if (label.childNodes !== null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 9) {
          $.streamList.forEach((stream) => {
            let width = "33.3%";
            let height = "28.3vh";
            if (stream.getId() == $.hiddenUid) {
              width = "0%";
              height = "0vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";
              // label.style.visibility = "hidden";
              label.firstChild.style.fontSize = "12px";
              if (label.childNodes !== null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 8) {
          $.streamList.forEach((stream) => {
            let width = "25%";
            let height = "42.5vh";
            if (stream.getId() == $.hiddenUid) {
              width = "0%";
              height = "0vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";
              // label.style.visibility = "hidden";
              label.firstChild.style.fontSize = "12px";
              if (label.childNodes !== null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 7) {
          $.streamList.forEach((stream, index) => {
            let width = "25%";
            let height = "";
            if (index > 0) {
              height = "42.5vh";
            } else {
              height = "85vh";
            }
            if (stream.getId() == $.hiddenUid) {
              width = "0%";
              height = "0vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";
              // label.style.visibility = "hidden";
              label.firstChild.style.fontSize = "12px";
              if (label.childNodes !== null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 6) {
          $.streamList.forEach((stream) => {
            let width = "33.3%";
            let height = "42.5vh";
            if (stream.getId() == $.hiddenUid) {
              width = "0%";
              height = "0vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";
              // label.style.visibility = "hidden";
              label.firstChild.style.fontSize = "12px";
              if (label.childNodes !== null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 5) {
          $.streamList.forEach((stream, index) => {
            let width = "33.3%";
            let height = "";
            if (index > 0) {
              height = "42.5vh";
            } else {
              height = "85vh";
            }
            if (stream.getId() == $.hiddenUid) {
              width = "0%";
              height = "0vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";
              // label.style.visibility = "hidden";
              label.firstChild.style.fontSize = "12px";
              if (label.childNodes !== null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 4) {
          $.streamList.forEach((stream) => {
            let width = "50%";
            let height = "42.5vh";
            if (stream.getId() == $.hiddenUid) {
              width = "0%";
              height = "0vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";
              // label.style.visibility = "hidden";
              label.firstChild.style.fontSize = "12px";
              if (label.childNodes !== null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 3) {
          $.streamList.forEach((stream, index) => {
            let width = "50%";
            let height = "";
            if (index > 0) {
              height = "42.5vh";
            } else {
              height = "85vh";
            }
            if (stream.getId() == $.hiddenUid) {
              width = "0%";
              height = "0vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";
              // label.style.visibility = "hidden";
              label.firstChild.style.fontSize = "12px";
              if (label.childNodes !== null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 2) {
          $.streamList.forEach((stream) => {
            let width = "50%";
            let height = "85vh";
            if (stream.getId() == $.hiddenUid) {
              width = "0%";
              height = "0vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";
              // label.style.visibility = "hidden";
              label.firstChild.style.fontSize = "12px";
              if (label.childNodes !== null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 1) {
          $.streamList.forEach((stream) => {
            let width = "100%";
            let height = "85vh";
            if (stream.getId() == $.hiddenUid) {
              width = "0%";
              height = "0vh";
            }
            console.log(
              `hidden: ${$.hiddenUid}, ${stream.getId()}, ${
                $.$store.state.isHostHidden
              }`,
              width,
              height
            );
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes !== null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        }

        // document.querySelector(`#ag-item-${$.localStream.getId()}`).style.bottom = "25px";
        //   if (document.querySelector(`#ag-item-${$.localStream.getId()}`)) {
        //     document.querySelector(
        //       `#ag-item-${$.localStream.getId()}`
        //     ).style.transitionDelay = "2s";
        //   }
      }
    },
    liveLayout() {
      const $ = this;
      let result = [];
      let isActiveScreenShare = $.$store.state.isScreenShare;
      let isActiveVideoShare = $.$store.state.isExternalVideoShared;
      let x,
        y = 0;
      let flag = 0;
      let shareCounterY = 0;
      let height = 0,
        width = 0;
      if ($.streamList.length === 1) {
        result.push({
          x: 0,
          y: 0,
          width: 1920,
          height: 1080,
          uid: $.streamList[0].getId(),
          zOrder: 0,
          alpha: 1,
        });
        return result;
      }
      if (!isActiveScreenShare == true && isActiveVideoShare == false) {
        width = 960;
        if ($.streamList.length % 2 == 0) {
          let n = $.streamList.length / 2;
          height = 1080 / n;
        } else {
          let n = ($.streamList.length + 1) / 2;
          height = 1080 / n;
        }
      } else if (!isActiveVideoShare == true && isActiveScreenShare == false) {
        width = 960;
        if ($.streamList.length % 2 == 0) {
          let n = $.streamList.length / 2;
          height = 1080 / n;
        } else {
          let n = ($.streamList.length + 1) / 2;
          height = 1080 / n;
        }
      }

      if ($.$store.state.isHostHidden) {
        $.streamList.forEach((item, i) => {
          if (item.getId() === $.localStream.getId()) {
            return;
          }
          if (!isActiveScreenShare == true && isActiveVideoShare == false) {
            if (i % 2 == 0) {
              x = 0;
            } else {
              x = 960;
            }
            flag = i;

            if (flag > 0 && flag % 2 == 0) {
              y += height;
            }
            if ($.streamList.length == i + 1 && $.streamList.length % 2 != 0) {
              x = 600;
            }
          } else if (
            !isActiveVideoShare == true &&
            isActiveScreenShare == false
          ) {
            if (i % 2 == 0) {
              x = 0;
            } else {
              x = 960;
            }
            flag = i;

            if (flag > 0 && flag % 2 == 0) {
              y += height;
            }
            if ($.streamList.length == i + 1 && $.streamList.length % 2 != 0) {
              x = 600;
            }
          } else {
            if (item.getId() == 10000320 || item.getId() == 666) {
              x = 0;
              y = 0;
              width = 1670;
              height = 1080;
            } else {
              x = 1670;
              width = 250;
              height = 200;
              if (i > 0) {
                if (shareCounterY == y) {
                  y += height;
                  shareCounterY = y;
                } else {
                  y = shareCounterY;
                  y += height;
                  shareCounterY = y;
                }
              }
            }
          }
          // console.log(
          //   `x: ${x}, y: ${y}, width: ${width}, height: ${height}, User: ${item.getId()}`
          // );
          result.push({
            x,
            y,
            width,
            height,
            uid: item.getId(),
            zOrder: 0,
            alpha: 1,
          });
        });
      } else {
        $.streamList.forEach((item, i) => {
          if (!isActiveScreenShare == true && isActiveVideoShare == false) {
            // if (i % 2 == 0) {
            //   x = 0;
            // } else {
            //   x = 960;
            // }
            // flag = i;

            // if (flag > 0 && flag % 2 == 0) {
            //   y += height;
            // }
            // if ($.streamList.length == i + 1 && $.streamList.length % 2 != 0) {
            //   x = 600;
            // }
            if (
              i == 0 &&
              (($.streamList.length > 0 && $.streamList.length <= 5) ||
                $.streamList.length == 7 ||
                $.streamList.length == 10 ||
                $.streamList.length == 13 ||
                $.streamList.length == 15 ||
                $.streamList.length == 17)
            ) {
              height = 1080;
            } else if (
              i > 0 &&
              $.streamList.length > 2 &&
              $.streamList.length < 9
            ) {
              height = 540;
            } else if (
              i > 0 &&
              $.streamList.length > 8 &&
              $.streamList.length < 13
            ) {
              height = 360;
            } else if ($.streamList.length > 12) {
              height = 270;
            }

            if ($.streamList.length > 1 && $.streamList.length < 5) {
              width = 960;
            } else if ($.streamList.length == 5) {
              width = 640;
            } else if ($.streamList.length <= 7 && $.streamList.length < 15) {
              width = 480;
            }

            if ($.streamList.length == 2) {
              if (i == 0) {
                x = 0;
                y = 0;
              } else if (i == 1) {
                x = 960;
                y = 0;
              }
            }

            if ($.streamList.length == 3) {
              if (i == 0) {
                x = 0;
                y = 0;
              } else if (i == 1) {
                x = 960;
                y = 0;
              } else if (i == 2) {
                x = 960;
                y = 540;
              }
            }

            if ($.streamList.length == 4) {
              height = 540;
              width = 960;
              if (i % 2 == 0) {
                x = 0;
              } else {
                x = 960;
              }
              if (i >= 2) {
                y = height;
              }
            }
            if ($.streamList.length == 5) {
              if (i == 0) {
                x = 0;
              } else if (i == 3) {
                x = 640;
              } else {
                x += 640;
              }

              if (i >= 3) {
                y = 540;
              } else {
                y = 0;
              }
            }
            if ($.streamList.length == 6) {
              height = 640;
              width = 540;
              if (i == 0 || i == 3) {
                x = 0;
              } else {
                x += 640;
              }
              if (i >= 3) {
                y = 540;
              } else {
                y = 0;
              }
            }
            if ($.streamList.length == 7) {
              if (i == 0) {
                x = 0;
              } else {
                if (i == 4) {
                  x = 0;
                }
                x += 480;
              }
              if (i >= 4) {
                y = 540;
              } else {
                y = 0;
              }
            }
            if ($.streamList.length == 8) {
              height = 480;
              width = 540;
              if (i == 0 || i == 4) {
                x = 0;
              } else {
                x += 480;
              }
              if (i >= 4) {
                y = 540;
              } else {
                y = 0;
              }
            }
            if ($.streamList.length == 9) {
              height = 640;
              width = 360;
              if (i == 0 || i == 3 || i == 6) {
                x = 0;
              } else {
                x += 640;
              }
              if (i >= 3) {
                y = 360;
              } else if (i >= 6) {
                y = 720;
              } else {
                y = 0;
              }
            }
            if ($.streamList.length == 10) {
              if (i == 0) {
                x = 0;
              } else {
                if (i == 4 || i == 7) {
                  x = 0;
                }
                x += 480;
              }
              if (i >= 7) {
                y = 720;
              }
              if (i >= 4) {
                y = 360;
              } else {
                y = 0;
              }
            }
            if ($.streamList.length == 11 || $.streamList.length == 14) {
              if (i == 0 || i == 1) {
                height = 540;
              }
            }

            if ($.streamList.length == 11) {
              if (i == 0 || i == 1) {
                x = 0;
              } else {
                if (i == 5 || i == 8) {
                  x = 0;
                }
                x += 480;
              }
              if (i >= 8) {
                y = 720;
              } else if (i >= 5) {
                y = 360;
              } else {
                if (i == 1) {
                  y = 540;
                } else {
                  y = 0;
                }
              }
            }

            if ($.streamList.length == 12) {
              height = 480;
              width = 360;
              if (i == 0 || i == 4 || i == 8) {
                x = 0;
              } else {
                x += 480;
              }
              if (i >= 8) {
                y = 720;
              }
              if (i >= 4) {
                y = 360;
              } else {
                y = 0;
              }
            }

            if ($.streamList.length == 13) {
              if (i == 0) {
                x = 0;
              } else {
                if (i == 4 || i == 7 || i == 10) {
                  x = 0;
                }
                x += 480;
              }
              if (i >= 10) {
                y = 810;
              } else if (i >= 7) {
                y = 540;
              } else if (i >= 4) {
                y = 270;
              } else {
                y = 0;
              }
            }

            if ($.streamList.length == 14) {
              if (i == 0 || i == 1) {
                x = 0;
              } else {
                if (i == 5 || i == 8 || i == 11) {
                  x = 0;
                }
                x += 480;
              }
              if (i >= 11) {
                y = 810;
              } else if (i >= 8) {
                y = 540;
              } else if (i >= 5) {
                y = 270;
              } else {
                if (i == 1) {
                  y = 540;
                } else {
                  y = 0;
                }
              }
            }

            if ($.streamList.length == 15) {
              if (i == 1 || i == 2) {
                height = 540;
              }
              if (i == 0) {
                height = 1080;
                x = 0;
                y = 0;
              } else {
                if (i == 1 || i == 2) {
                  x = 0;
                }
                x += 384;
              }

              if (i >= 12) {
                y = 810;
              } else if (i >= 9) {
                y = 540;
              } else if (i >= 6) {
                y = 270;
              } else {
                if (i == 2) {
                  y = 540;
                } else {
                  y = 0;
                }
              }
            }
            if ($.streamList.length == 16) {
              height = 480;
              width = 270;
              if (i == 0 || i == 4 || i == 8 || i == 12) {
                x = 0;
              } else {
                x += 480;
              }

              if (i >= 12) {
                y = 810;
              } else if (i >= 8) {
                y = 540;
              } else if (i >= 4) {
                y = 270;
              } else {
                y = 0;
              }
            }

            if ($.streamList.length == 17) {
              if (i == 0) {
                x = 0;
              } else {
                if (i == 1 || i == 5 || i == 9 || i == 13) {
                  x = 0;
                }
                x += 384;
              }
              if (i >= 13) {
                y = 840;
              } else if (i >= 9) {
                y = 540;
              } else if (i >= 5) {
                y = 270;
              } else {
                y = 0;
              }
            }
          } else if (
            !isActiveVideoShare == true &&
            isActiveScreenShare == false
          ) {
            // if (i % 2 == 0) {
            //   x = 0;

            // } else {
            //   x = 960;
            // }
            // flag = i;

            // if (flag > 0 && flag % 2 == 0) {
            //   y += height;
            // }
            // if ($.streamList.length == i + 1 && $.streamList.length % 2 != 0) {
            //   x = 600;
            // }
            if (
              i == 0 &&
              (($.streamList.length > 0 && $.streamList.length <= 5) ||
                $.streamList.length == 7 ||
                $.streamList.length == 10 ||
                $.streamList.length == 13 ||
                $.streamList.length == 15 ||
                $.streamList.length == 17)
            ) {
              height = 1080;
            } else if (
              i > 0 &&
              $.streamList.length > 2 &&
              $.streamList.length < 9
            ) {
              height = 540;
            } else if (
              i > 0 &&
              $.streamList.length > 8 &&
              $.streamList.length < 13
            ) {
              height = 360;
            } else if ($.streamList.length > 12) {
              height = 270;
            }

            if ($.streamList.length > 1 && $.streamList.length < 5) {
              width = 960;
            } else if ($.streamList.length == 5) {
              width = 640;
            } else if ($.streamList.length <= 7 && $.streamList.length < 15) {
              width = 480;
            }

            if ($.streamList.length == 2) {
              if (i == 0) {
                x = 0;
                y = 0;
              } else if (i == 1) {
                x = 960;
                y = 0;
              }
            }

            if ($.streamList.length == 3) {
              if (i == 0) {
                x = 0;
                y = 0;
              } else if (i == 1) {
                x = 960;
                y = 0;
              } else if (i == 2) {
                x = 960;
                y = 540;
              }
            }

            if ($.streamList.length == 4) {
              height = 540;
              width = 960;
              if (i % 2 == 0) {
                x = 0;
              } else {
                x = 960;
              }
              if (i >= 2) {
                y = height;
              }
            }
            if ($.streamList.length == 5) {
              if (i == 0) {
                x = 0;
              } else if (i == 3) {
                x = 640;
              } else {
                x += 640;
              }

              if (i >= 3) {
                y = 540;
              } else {
                y = 0;
              }
            }
            if ($.streamList.length == 6) {
              height = 640;
              width = 540;
              if (i == 0 || i == 3) {
                x = 0;
              } else {
                x += 640;
              }
              if (i >= 3) {
                y = 540;
              } else {
                y = 0;
              }
            }
            if ($.streamList.length == 7) {
              if (i == 0) {
                x = 0;
              } else {
                if (i == 4) {
                  x = 0;
                }
                x += 480;
              }
              if (i >= 4) {
                y = 540;
              } else {
                y = 0;
              }
            }
            if ($.streamList.length == 8) {
              height = 480;
              width = 540;
              if (i == 0 || i == 4) {
                x = 0;
              } else {
                x += 480;
              }
              if (i >= 4) {
                y = 540;
              } else {
                y = 0;
              }
            }
            if ($.streamList.length == 9) {
              height = 640;
              width = 360;
              if (i == 0 || i == 3 || i == 6) {
                x = 0;
              } else {
                x += 640;
              }
              if (i >= 3) {
                y = 360;
              } else if (i >= 6) {
                y = 720;
              } else {
                y = 0;
              }
            }
            if ($.streamList.length == 10) {
              if (i == 0) {
                x = 0;
              } else {
                if (i == 4 || i == 7) {
                  x = 0;
                }
                x += 480;
              }
              if (i >= 7) {
                y = 720;
              }
              if (i >= 4) {
                y = 360;
              } else {
                y = 0;
              }
            }
            if ($.streamList.length == 11 || $.streamList.length == 14) {
              if (i == 0 || i == 1) {
                height = 540;
              }
            }

            if ($.streamList.length == 11) {
              if (i == 0 || i == 1) {
                x = 0;
              } else {
                if (i == 5 || i == 8) {
                  x = 0;
                }
                x += 480;
              }
              if (i >= 8) {
                y = 720;
              } else if (i >= 5) {
                y = 360;
              } else {
                if (i == 1) {
                  y = 540;
                } else {
                  y = 0;
                }
              }
            }

            if ($.streamList.length == 12) {
              height = 480;
              width = 360;
              if (i == 0 || i == 4 || i == 8) {
                x = 0;
              } else {
                x += 480;
              }
              if (i >= 8) {
                y = 720;
              }
              if (i >= 4) {
                y = 360;
              } else {
                y = 0;
              }
            }

            if ($.streamList.length == 13) {
              if (i == 0) {
                x = 0;
              } else {
                if (i == 4 || i == 7 || i == 10) {
                  x = 0;
                }
                x += 480;
              }
              if (i >= 10) {
                y = 810;
              } else if (i >= 7) {
                y = 540;
              } else if (i >= 4) {
                y = 270;
              } else {
                y = 0;
              }
            }

            if ($.streamList.length == 14) {
              if (i == 0 || i == 1) {
                x = 0;
              } else {
                if (i == 5 || i == 8 || i == 11) {
                  x = 0;
                }
                x += 480;
              }
              if (i >= 11) {
                y = 810;
              } else if (i >= 8) {
                y = 540;
              } else if (i >= 5) {
                y = 270;
              } else {
                if (i == 1) {
                  y = 540;
                } else {
                  y = 0;
                }
              }
            }

            if ($.streamList.length == 15) {
              if (i == 1 || i == 2) {
                height = 540;
              }
              if (i == 0) {
                height = 1080;
                x = 0;
                y = 0;
              } else {
                if (i == 1 || i == 2) {
                  x = 0;
                }
                x += 384;
              }

              if (i >= 12) {
                y = 810;
              } else if (i >= 9) {
                y = 540;
              } else if (i >= 6) {
                y = 270;
              } else {
                if (i == 2) {
                  y = 540;
                } else {
                  y = 0;
                }
              }
            }
            if ($.streamList.length == 16) {
              height = 480;
              width = 270;
              if (i == 0 || i == 4 || i == 8 || i == 12) {
                x = 0;
              } else {
                x += 480;
              }

              if (i >= 12) {
                y = 810;
              } else if (i >= 8) {
                y = 540;
              } else if (i >= 4) {
                y = 270;
              } else {
                y = 0;
              }
            }

            if ($.streamList.length == 17) {
              if (i == 0) {
                x = 0;
              } else {
                if (i == 1 || i == 5 || i == 9 || i == 13) {
                  x = 0;
                }
                x += 384;
              }
              if (i >= 13) {
                y = 840;
              } else if (i >= 9) {
                y = 540;
              } else if (i >= 5) {
                y = 270;
              } else {
                y = 0;
              }
            }
          } else {
            if (item.getId() == 10000320 || item.getId() == 666) {
              x = 0;
              y = 0;
              width = 1670;
              height = 1080;
            } else {
              x = 1670;
              width = 250;
              height = 200;
              if (i > 0) {
                if (shareCounterY == y) {
                  y += height;
                  shareCounterY = y;
                } else {
                  y = shareCounterY;
                  y += height;
                  shareCounterY = y;
                }
              }
            }
          }
          // console.log(
          //   `x: ${x}, y: ${y}, width: ${width}, height: ${height}, User: ${item.getId()}`
          // );
          result.push({
            x,
            y,
            width,
            height,
            uid: item.getId(),
            zOrder: 0,
            alpha: 1,
          });
        });
      }
      return result;
    },
    removeInjectedVideo() {
      const $ = this;
      $.isSharingExternalVideo = false;
      $.$store.state.isExternalVideoShared = false;
      // document.getElementById("userVideos").style.display = "none"
      this.client.removeInjectStreamUrl($.shareVideoUrl.url);
      $.$root.$emit("removeShareVideo");
      $.isScreenShareLoaded = false;
      $.displayMode = "tile";
      $.shareVideoUrl.url = "";
    },
    injectVideo() {
      let $ = this;
      if ($.shareVideoUrl.url === "") {
        this.$toast.open({
          message: "Please enter url",
          type: "error",
          position: "top",
          queue: true,
        });
      } else {
        if (
          $.shareVideoUrl.url.endsWith(".mp4") ||
          $.shareVideoUrl.url.endsWith(".mov") ||
          $.shareVideoUrl.url.endsWith(".avi") ||
          $.shareVideoUrl.url.endsWith(".3gp") ||
          $.shareVideoUrl.url.endsWith(".ogg") ||
          $.shareVideoUrl.url.endsWith(".wmv") ||
          $.shareVideoUrl.url.endsWith(".flv") ||
          $.shareVideoUrl.url.endsWith(".m3u8") ||
          $.shareVideoUrl.url.endsWith(".webm")
        ) {
          $.isSharingExternalVideo = true;
          $.$store.state.isExternalVideoShared = true;
          // document.getElementById("userVideos").style.display = "block"
          // console.log("Inject Video");
          // var InjectStreamConfig = {
          //   width: 1920,
          //   height: 1080,
          //   videoGop: 30,
          //   videoFramerate: 30,
          //   videoBitrate: 3000,
          //   audioSampleRate: AgoraRTC.AUDIO_SAMPLE_RATE_48000,
          //   audioChannels: 1,
          // };
          var InjectStreamConfig = {
            width: 1920,
            height: 1080,
            videoBitrate: 2080,
            videoFramerate: 15,
            audioSampleRate: AgoraRTC.AUDIO_SAMPLE_RATE_48000,
            audioBitrate: 48,
            audioChannels: 1,
            videoGop: 30,
            videoCodecProfile: 100,
          };
          // $.streamList.map(stream => {
          //   $.displayPanel(stream)
          // })
          // https://meetbeans-data.s3.ap-south-1.amazonaws.com/70653798_2400985073303778_6694423940202092437_n.mp4
          $.$root.$emit("screenShareLoaderStart");
          $.isScreenShareLoaded = true;
          $.$root.$emit("shareVideo");
          $.client
            .addInjectStreamUrl($.shareVideoUrl.url, InjectStreamConfig)
            .then(() => {
              setTimeout(function() {
                $.isScreenShareLoaded = false;
              }, 4000);
              $.$root.$emit("screenShareLoaderStop");
            });
          let data = {
            cname: this.channel,
            channel_id: this.$route.params.session,
            appId: this.appID,
            uid: this.uid,
            recordingId: 666,
          };
          this.$store
            .dispatch("updateEventLayoutRecording", data)
            .then((resp) => {
              if (resp.status === 200) {
                // Acquire and Start recording
                console.log("update rec screen resp");
                // this.$store.state.sid = resp.data.sid;
              } else {
                this.$toast.open({
                  message: "Unable to add new video in recording !",
                  type: "error",
                  position: "bottom",
                  queue: true,
                });
              }
            });
        } else {
          Swal.fire(
            "Sorry, we only support below file urls.",
            "MP4, MOV, AVI, 3GP, OGG, FLV, WMV, M3U8, WEBM File formats.",
            "error"
          );
        }
      }
    },
    totalVotesForHost(answers) {
      // console.log("Totalvotesforhost");

      let totalVotes = 0;
      answers.filter((a) => {
        if (!isNaN(a.votes) && a.votes > 0) totalVotes += parseInt(a.votes);
      });
      return totalVotes;
    },

    calcAnswersForHost(answers) {
      // console.log("calcAnswersForHost");
      if (this.totalVotesForHost(answers) === 0)
        return answers.map((a) => {
          a.percent = "0%";
          return a;
        });
      //Calculate percent
      return answers.filter((a) => {
        if (!isNaN(a.votes) && a.votes > 0)
          a.percent =
            Math.round(
              (parseInt(a.votes) / this.totalVotesForHost(answers)) * 100
            ) + "%";
        else a.percent = "0%";

        return a;
      });
    },
    addNewPoll() {
      let $ = this;
      this.visibleResults = false;
      // console.log("Visibility: ", this.visibleResults);
      let da = {
        channel_id: this.$route.params.session,
      };
      this.$store.dispatch("getEventPolls", da).then((resp) => {
        if (resp.data.status === "success") {
          $.polls = resp.data.data;
          // console.log("Polls: ", $.polls);
          $.polls.sort(function(a, b) {
            return new Date(a.createdAt) - new Date(b.createdAt);
          });
        }
      });
    },
    handleVote(a) {
      a.votes++;
      a.selected = true;
      this.visibleResults = true;

      // let obj = { votes: a.votes, totalVotes: this.totalVotes };
      this.clientPoll.answers.map((answer) => {
        if (answer.text === a.text) {
          answer.votes = a.votes;
        }
      });
      let da = {
        channel_id: this.$route.params.session,
        answer: {
          poll_id: this.clientPoll.poll_id,
          answer: a.text,
        },
      };
      this.$store.dispatch("storeEventAnswer", da).then((resp) => {
        if (resp.data.status === "success") {
          // if (this.customId) obj.customId = this.customId;
          this.$root.$emit("updateVotes", this.clientPoll);
        }
      });
    },
    addVote(obj) {
      console.log("You voted " + obj.votes + "!");
      obj = {};
    },
    handlePollClientClick(e) {
      // console.log("Hello1: ", e);
      // console.log("Hello1: ", e);
      e.target.background = "lightgreen";
    },
    showClientPoll() {
      let $ = this;
      console.log("ShowCLientPoll: ", $.clientPoll);
      // $('#showClientModal').modal('show');
      document.getElementById("showCientModalButton").click();
    },
    handlePoll() {
      // console.log("PollData: ", this.poll);
      if (this.poll.question === "") {
        this.$toast.open({
          message: "Please enter the question.",
          type: "error",
          position: "top",
          queue: true,
        });
      } else {
        this.poll.answers.map((answer, index) => {
          if (answer.text === "") {
            this.poll.answers.splice(index, 1);
          }
        });
        this.polls.push(this.poll);
        let da = {
          channel_id: this.$route.params.session,
          poll: this.poll,
        };
        this.$store.dispatch("storeEventPoll", da).then((resp) => {
          if (resp.data.status === "success") {
            this.$root.$emit("showPollToUsers", resp.data.data);
            this.$toast.open({
              message: "Your poll has been sent to everyone.",
              type: "success",
              position: "top",
              queue: true,
            });
            this.poll = {
              question: "",
              answers: [
                {
                  text: "",
                  votes: 0,
                },
              ],
            };
          }
        });
      }
    },
    removeOption: function(i) {
      this.poll.answers.splice(i, 1);
    },
    addOptions: function() {
      this.poll.answers.push({
        text: "",
        votes: 0,
      });
    },
    handleHideHost() {
      this.removeStream(this.localStream.getId());
      this.localStream.stop();
      this.localStream.close();
      this.client.unpublish(this.localStream);
      let userInfo = JSON.parse(localStorage.getItem("user_info"));
      console.log("USERINFO: ", userInfo);
      console.log("Streams: ", this.streamList);
      this.canvasLayout();
      this.$toast.open({
        message: "You are hidden now.",
        type: "success",
        position: "top",
        queue: true,
      });
    },
    handleUnhideHost() {
      let $ = this;
      if (document.querySelector(".videoControlBtn")) {
        document.querySelector(".videoControlBtn").classList.remove("off");
      }
      if (document.querySelector(".audioControlBtn")) {
        document.querySelector(".audioControlBtn").classList.remove("off");
      }
      $.isHostHidden = false;
      let userInfo = JSON.parse(localStorage.getItem("user_info"));
      console.log("USERINFO: ", userInfo);
      $.localStream = $.streamInit(
        $.uid,
        $.attendeeMode,
        $.videoProfile,
        $.config
      );
      $.localStream.init(
        () => {
          if ($.attendeeMode !== "audience") {
            $.addStream($.localStream, true);
            $.$toast.open({
              message: "You are going to live again.",
              type: "success",
              position: "top",
            });
            $.client.publish($.localStream, (err) => {
              console.log("Publish local stream error: " + err);
            });
            $.showControls();
            // $.$root.$emit("startSession", $.uid);
            // $.$root.$emit("getAudience");
            // $.$root.$emit('submitSetting')
            // if (!$.$store.state.isSpeaker)
            //   jquery(window).on("beforeunload", function() {
            //     $.handleExit();
            //     return "Are you sure you want to leave?";
            //   });
            // jquery(window).on("unload", function() {
            //   $.handleExit();
            // });
          }
          $.readyState = true;
        },
        (err) => {
          console.log("getUserMedia failed", err);
          if (err.info === "Permission denied") {
            // handle Permission denied case
          }
          $.readyState = true;
        }
      );
    },
    toggleFullScreen() {
      const elem = document.getElementById("ag-canvas");
      if (!document.fullscreenElement) {
        this.fullscreen = true;
        elem.requestFullscreen();
      } else {
        if (document.exitFullscreen) {
          this.fullscreen = false;
          document.exitFullscreen();
        }
      }
    },
    updateConnectionStatus() {
      var connection =
        navigator.connection ||
        navigator.mozConnection ||
        navigator.webkitConnection;
      // console.log(
      //   "Connection type changed from " +
      //     this.networkStatus +
      //     " to " +
      //     connection.effectiveType
      // );
      this.networkStatus = connection.effectiveType;
    },
    handleVideoInfo(stream) {
      const $ = this;
      // video information code
      let styles = {
        position: "absolute",
        bottom: "120px",
        background: "rgba(10, 10, 10, 0.75)",
        color: "#fff",
        padding: "4px",
        "font-size": "12px",
        "font-weight": "bold",
        width: "120px",
        height: "60px",
      };
      if ($.isScreenBeingSharedByRemote || $.isSharingExternalVideo) {
        styles = {
          position: "absolute",
          bottom: "0px",
          background: "rgba(10, 10, 10, 0.75)",
          color: "#fff",
          padding: "4px",
          "font-size": "12px",
          "font-weight": "bold",
          width: "120px",
          height: "27px",
        };
      }
      // const styleIcons = {
      //   position: "relative",
      //   background: "rgba(10, 10, 10, 0.75)",
      //   color: "#fff",
      //   padding: "4px",
      //   width: "fit-content",
      //   "font-size": "18px",
      // };
      const targetElement = document.getElementById("player_" + stream.getId());
      if (targetElement === null) {
        return;
      }
      const videoInfo = document.getElementById(`video-info-${stream.getId()}`);
      if (typeof videoInfo != "undefined" && videoInfo != null) {
        return;
      }
      let da = {
        channel_id: this.$route.params.session,
      };
      $.updateConnectionStatus();
      if ($.networkStatus === "4g") {
        setTimeout(() => {
          let networkIcon = document.getElementById("strongNetworkIcon");
          if (networkIcon !== null) {
            document.getElementById("strongNetworkIcon").style.display = "none";
          }
        }, 3000);
      }
      this.$store.dispatch("getEventMembersData", da).then((resp) => {
        if (resp.data.status === "success") {
          resp.data.data.forEach((m) => {
            if (m.uid == stream.getId()) {
              const label = document.createElement("label");
              label.innerHTML = m.role.toUpperCase();
              if (m.role === "host") {
                label.setAttribute("class", "badge badge-danger");
              } else if (m.role == "audience") {
                label.innerHTML = "ATTENDEE";
                label.setAttribute("class", "badge badge-primary");
              } else {
                label.setAttribute("class", "badge badge-info");
              }
              label.style.position = "absolute";
              label.style.left = "10px";
              label.style.top = "10px";
              label.style.zIndex = "9";
              targetElement.appendChild(label);
              const videoInfo = document.getElementById(`video-info-${m.uid}`);
              if (typeof videoInfo == "undefined" || videoInfo === null) {
                const newElement = document.createElement("div");
                newElement.setAttribute("id", `video-info-${stream.getId()}`);
                newElement.setAttribute("class", "video-info");
                newElement.style.zIndex = "2";
                // const audioIndicator = document.createElement("div");
                // audioIndicator.setAttribute("style", "display: flex;align-items: center;margin: 3px");
                // const leftIndicator = document.createElement("div");
                // leftIndicator.setAttribute("class", `audio-indicator left-audio-indicator-${stream.getId()}`);
                // const mainIndicator = document.createElement("div");
                // mainIndicator.setAttribute("class", `audio-indicator main-audio-indicator-${stream.getId()}`);
                // const rightIndicator = document.createElement("div");
                // rightIndicator.setAttribute("class", `audio-indicator right-audio-indicator-${stream.getId()}`);
                //
                // audioIndicator.appendChild(leftIndicator);
                // audioIndicator.appendChild(mainIndicator);
                // audioIndicator.appendChild(rightIndicator);
                //
                // newElement.appendChild(audioIndicator);

                if (m.company !== "" && m.designation !== "") {
                  newElement.innerHTML += `<p id="m_name" style='color: #FFB229;font-size: 12px;padding-top: 4px;margin-bottom: 0px;'>${m.name}</p><p id="desg_cpy" style='margin-bottom: 0px;font-size: 12px'>${m.designation}, ${m.company}</p>`;
                } else {
                  newElement.innerHTML += `<p id="m_name" style='color: #FFB229;font-size: 12px;padding-top: 4px;margin-bottom: 0px;'>${m.name}</p>`;
                }
                Object.assign(newElement.style, styles);
                targetElement.appendChild(newElement);
                if (stream.getId() != $.localStream.getId()) {
                  // Object.assign(newElement.style, styles);
                  const element = `
                    <div class="main-div" style="z-index:10" >
                        <span class="audio-icon-div" style="z-index:10000">
                            <i class="fas fa-microphone-slash audio" type="button" style="display: none;background: transparent"></i>
                        </span>
                        <span class="video-icon-div" style="z-index:10000">
                            <i class="fas fa-video-slash video" type="button" style="display: none;background: transparent"></i>
                        </span>
                    </div>
                `;
                  // $.handleAudioVolume(stream, true);
                  // $.handleIsStreamHasVideo(stream, true);
                  jquery(newElement).append(element);
                }
                // jquery(".audio-icon-div").click(() => {
                //   $.handleAudio(stream);
                // });
                // jquery(".video-icon-div").click(() => {
                //   $.handleVideo(stream);
                // });
                // $.handleMediaSetting(newElement);
              } else {
                // var para = document.createElement("div");
                // para.innerHTML = "OFFLINE";
                // para.setAttribute("id", "offline");
                // para.style.display = "none";
                // targetElement.appendChild(para);
              }
            }
          });
        }
      });
      // video information code
    },
    handleMuteAudio(uid) {
      jquery(`#video-info-${uid}>.main-div>.audio-icon-div>.audio`).show();
    },
    handleUnmuteAudio(uid) {
      jquery(`#video-info-${uid}>.main-div>.audio-icon-div>.audio`).hide();
    },
    handleMuteVideo(uid) {
      jquery(`#video-info-${uid}>.main-div>.video-icon-div>.video`).show();
    },
    handleUnmuteVideo(uid) {
      jquery(`#video-info-${uid}>.main-div>.video-icon-div>.video`).hide();
    },
    handleAudioVolume(stream, control) {
      // const $  = this;
      if (control === true) {
        let audioLevel = "";
        this.audioIndicatorInterval = setInterval(function() {
          if (
            stream.getId() !== 10000320 ||
            stream.getId() !== 1000000001 ||
            stream.getId() !== 666
          ) {
            audioLevel = stream.getAudioLevel();
            console.log(audioLevel);
            // $.handleAudioVolume(audioLevel);
            // Use audioLevel to render the UI
            if (audioLevel <= 0) {
              jquery(".audio").removeClass("fa-microphone");
              jquery(".audio").addClass("fa-microphone-slash");
            } else {
              jquery(".audio").removeClass("fa-microphone-slash");
              jquery(".audio").addClass("fa-microphone");
            }
          }
        }, 1000);
      } else {
        //To do
      }
    },
    handleIsStreamHasVideo(stream, control) {
      if (control === true) {
        setInterval(() => {
          let hasVideo = stream.isVideoOn();
          if (hasVideo === false) {
            jquery(".video").removeClass("fa-video");
            jquery(".video").addClass("fa-video-slash");
          } else if (hasVideo === true) {
            jquery(".video").removeClass("fa-video-slash");
            jquery(".video").addClass("fa-video");
          }
        }, 1000);
      } else {
        // todo
        // return;
      }
    },
    handleAudio(stream) {
      // const $ = this;
      if (stream.isAudioOn()) {
        // $.handleAudioVolume(stream, false);
        jquery(".audio").removeClass("fa-microphone");
        clearInterval(this.audioIndicatorInterval);
        jquery(".audio").addClass("fa-microphone-slash");
        stream.muteAudio();
      } else {
        // $.handleAudioVolume(stream, true);
        jquery(".audio").removeClass("fa-microphone-slash");
        jquery(".audio").addClass("fa-microphone");
        stream.unmuteAudio();
      }
    },
    handleVideo(stream) {
      // const $ = this;
      if (stream.isVideoOn()) {
        // $.handleIsStreamHasVideo(stream, false);
        jquery(".video").removeClass("fa-video");
        jquery(".video").addClass("fa-video-slash");
        stream.muteVideo();
      } else {
        // $.handleIsStreamHasVideo(stream, true);
        jquery(".video").removeClass("fa-video-slash");
        jquery(".video").addClass("fa-video");
        stream.unmuteVideo();
      }
    },
    handleMediaSetting(element) {
      // const $ = this;
      const newElement = `
          <div class="main-div">
            <span class="audio-icon-div" style="display: none">
                  <i class="fas fa-microphone-slash" type="button"></i>
              </span>
              <span class="video-icon-div" style="display: none">
                  <i class="fas fa-video-slash" type="button"></i>
              </span>
          </div>
        `;
      jquery(element).appendChild(newElement);
    },
    handleWithdraw() {
      const $ = this;
      $.isHandRaised = false;
      // console.log(
      //   "%c:inside handle withdraw--",
      //   "background: #ff00dd; color: #00ff00"
      // );
      if ($.handRequest.length > 0) {
        $.handRequest.forEach((item, i) => {
          if (item == $.uid) {
            $.handRequest.splice(i, 1);
          }
        });
      }
      $.$root.$emit("handleWithdraw");
    },
    isShowLeave() {
      const $ = this;
      const memberList = $.$store.memberList;
      $.streamList.forEach((stream) => {
        memberList.forEach((member) => {
          if (stream.getId() == member.uid) {
            if (member.role === "audience") {
              return true;
            }
          }
        });
      });
      return false;
    },
    beforeTabClose() {
      let cnfrm = window.confirm("Do you really want to leave the page ?");
      if (cnfrm) {
        this.$root.$emit("pleaseHandleDeclineByHost", this.uid);
        this.handleExit();
      }
    },
    handleLeave(uid) {
      const $ = this;
      if ($.attendeeMode === "audience") {
        $.streamList.forEach((stream) => {
          if (stream.getId() == $.uid) {
            $.client.unpublish(stream);
            $.removeStream(stream.getId());
            $.isControl = false;
          }
        });
      } else {
        if ($.streamList.length > 0) {
          $.streamList.forEach((stream) => {
            if (stream.getId() == uid) {
              $.$root.$emit("clientScreenShareStopped", 10000320);
              // $.removeStream(uid);
              $.$root.$emit("pleaseDeleteLocalStream", uid);
            }
          });
        }
      }
    },
    showControls: function() {
      //  retrun true false
      const $ = this;
      $.streamList.forEach((stream) => {
        if (stream.getId() == $.uid) {
          $.isControl = true;
        }
      });
    },
    getAgoraTokenFunction: function() {
      const $ = this;
      let data = {
        channel_id: this.$route.params.session,
      };
      this.$store.dispatch("getEventAgoraToken", data).then((resp) => {
        if (resp.data.status === "success") {
          $.token = resp.data.data.rtc_token;
          $.channel = resp.data.data.unique_id;
          $.channel_name = resp.data.data.channel_name;
          $.attendeeMode = resp.data.data.role;
          $.uid = resp.data.data.uid;
          // console.log("Uid vs: ", $.uid, "token: ", $.token);
          $.$store.state.role = resp.data.data.role;
          this.handleClient();

          //Before tab close
          // if (this.attendeeMode === 'host') {
          //   window.addEventListener('beforeunload', this.beforeTabClose())
          // }
        } else {
          this.$toast.open({
            message: resp.data.data,
            type: "error",
            position: "top",
            queue: true,
          });
        }
      });
    },
    breakSession() {
      try {
        clearInterval(this.audioIndicatorInterval);
        this.$store.state.isSessionTimerDisabled = false;
        this.$store.state.isLive = false;
        this.$store.state.isNetworking = true;
        this.$store.state.isBreak = true;
        this.$store.state.isEnd = false;
        this.$store.state.isScreenShare = false;
        this.postMeetingStatus();
        this.$store.state.streamCount = 0;
        this.client && this.client.unpublish(this.localStream);
        if (this.isSharingExternalVideo) {
          this.removeInjectedVideo();
        }
        this.isSharingExternalVideo = false;
        this.$store.state.isExternalVideoShared = false;
        this.localStream && this.localStream.close();
        this.client &&
          this.client.leave(
            () => {
              console.log("Client succeed to leave.");
            },
            () => {
              console.log("Client failed to leave.");
            }
          );
        this.stopRecording();
        this.streamList = [];
        this.handRequest = [];
        this.$root.$emit("emptyHandRaise");
        this.$root.$emit("notifyUserOnBreak");
        if (this.streamList.length > 0) {
          this.streamList.forEach((stream) => {
            let obj = document.querySelector("#ag-item-" + stream.getId());
            obj.remove();
          });
        }
        this.streamList = [];
      } finally {
        this.readyState = false;
        this.client = null;
        this.localStream = null;
        this.streamList = [];
        this.handRequest = [];
      }
    },
    endSession() {
      const $ = this;
      try {
        // this.$root.$emit("stopCamera");
        // this.stopCamera();
        $.localStream.preloadEffect(
          1,
          "https://meetbeans-data.s3.ap-south-1.amazonaws.com/sound_effects/exit.mp3",
          function(err) {
            if (err) {
              console.error("Failed to preload effect, reason: ", err);
            } else {
              console.log("Effect is preloaded successfully");
              $.localStream.stopEffect(
                {
                  soundId: 2,
                  filePath:
                    "https://meetbeans-data.s3.ap-south-1.amazonaws.com/sound_effects/exit.mp3",
                },
                function(err) {
                  if (err) {
                    console.log("audio error");
                  }
                }
              );
            }
          }
        );
        clearInterval(this.audioIndicatorInterval);

        this.$root.$emit("takeFeedbackFromUser");
        this.$store.state.isSessionTimerDisabled = false;
        this.$store.state.isLive = false;
        this.$store.state.isNetworking = true;
        this.$store.state.isBreak = false;
        this.$store.state.isEnd = true;
        this.$store.state.isScreenShare = false;
        if (this.isSharingExternalVideo) {
          this.removeInjectedVideo();
        }
        this.isSharingExternalVideo = false;
        this.$store.state.isExternalVideoShared = false;
        this.postMeetingStatus();
        this.$store.state.streamCount = 0;
        this.stopRecording();
        this.localStream.stop();
        this.localStream.close();
        this.client.unpublish(this.localStream);
        this.client.leave(
          () => {
            console.log("Client succeed to leave.");
          },
          () => {
            console.log("Client failed to leave.");
          }
        );
        this.client.stopLiveStreaming(
          `${this.facebookStreamUrl}/${this.$store.state.streamKey}`
        );
        this.streamList = [];
        this.handRequest = [];
        this.$root.$emit("emptyHandRaise");
        // Client will do same operation as break session
        this.$root.$emit("notifyUserOnBreak");
        this.$root.$emit("notifySessionEnd");
        if (this.streamList.length > 0) {
          this.streamList.forEach((stream) => {
            let obj = document.querySelector("#ag-item-" + stream.getId());
            obj.remove();
          });
        }
        this.streamList = [];
      } finally {
        this.readyState = false;
        this.client = null;
        this.localStream = null;
        this.streamList = [];
        this.handRequest = [];
        this.$root.$emit("takeFeedback");
      }
      document.getElementById("strongNetworkIcon").style.display = "block";
    },
    stopRecording() {
      let data = {
        cname: this.channel,
        channel_id: this.$route.params.session,
        appId: this.appID,
        uid: this.uid,
      };
      this.$store.dispatch("stopEventRecording", data).then((resp) => {
        if (resp.status === 200) {
          console.log("Stopped rec: ", resp);
          timer.stop();
        } else if (resp.status === 206) {
          this.$toast.open({
            message:
              "Allow recording of atleast 30 seconds before you stop recording",
            type: "info",
            position: "top",
            queue: true,
          });
        } else {
          console.log("Error: ", resp);
        }
      });
    },
    postMeetingStatus() {
      let data = {
        channel_id: this.$route.params.session,
      };
      this.$store.dispatch("storeEventMeetingStates", data).then((resp) => {
        if (resp.data.status === "success") {
          console.log("Wonderful states stored");
        } else {
          this.$toast.open({
            message: resp.data.data,
            type: "error",
            position: "top",
            queue: true,
          });
        }
      });
    },
    handleHandRaise() {
      const $ = this;
      let repeatition = this.handRequest.some((item) => {
        return item == $.uid;
      });
      if (repeatition) {
        this.$toast.open({
          message: "You are already live.",
          type: "error",
          position: "top",
          queue: true,
        });
        return;
      }
      $.handRequest.push($.uid);
      let deviceInfo = {};
      DetectRTC.load(function() {
        deviceInfo.browserName = DetectRTC.browser.name;
        deviceInfo.browserVersion = DetectRTC.browser.version;
        deviceInfo.osName = DetectRTC.osName;
        deviceInfo.osVersion = DetectRTC.osVersion;
        deviceInfo.meetsSystemRequirements = AgoraRTC.checkSystemRequirements();
        console.log(
          `browser name: ${deviceInfo.browserName}, browser version: ${deviceInfo.browserVersion}, os name: ${deviceInfo.osName}, os version: ${deviceInfo.osVersion}, checkSystemRequirements: ${deviceInfo.meetsSystemRequirements}`
        );
        $.$root.$emit("handleHandRaise", deviceInfo);
        $.isHandRaised = true;
        // console.log(
        //   "%c:$.handRequest from video call--",
        //   "background: #ff00dd; color: #00ff00",
        //   $.handRequest
        // );
        $.getHandRaiseStatus();
      });
    },
    getHandRaiseStatus() {
      // get the status for the hand raise
      const $ = this;
      let handRequestLength = $.handRequest.length;
      // handRaise array
      //  waiting for approval from host
      //  Your sequesnece number is 2
      //
      // if ($.streamList.getID() === $.uid) {
      //
      // }
      if (!$.handRequest.includes($.uid)) {
        $.isHandRaised = false;
      }
      if (handRequestLength === 1) {
        $.senderRaisedHandStatus = "Waiting approval from host";
      } else if (handRequestLength > 1) {
        const indexOfUser = $.handRequest.indexOf($.uid);
        $.senderRaisedHandStatus = `Your sequence number is ${indexOfUser}`;
      } else {
        console.log("HandRaise status not found");
      }
    },
    handleSpeakerStream() {
      const $ = this;
      if ($.isSpeakerLive) {
        $.isSpeakerLive = false;
        // console.log("Something 1!!");
        $.isControl = false;
        $.streamList.forEach((stream) => {
          // console.log("speaker stream: ", stream, $.streamList);
          if (stream.getId() == $.uid) {
            this.removeStream(this.localStream.getId());
            this.canvasLayout();
            this.localStream.stop();
            this.localStream.close();
            this.client.unpublish(this.localStream);
          }
        });
      } else {
        $.isSpeakerLive = true;
        $.localStream = this.streamInit(
          $.uid,
          "host",
          $.videoProfile,
          $.config
        );
        $.localStream.init(
          () => {
            // $.addCanvas();
            // Find the canvas element to capture
            // var canvasElt = document.querySelector("#canvaslocal");

            // Get the stream
            // var stream = canvasElt.captureStream(15); // 25 FPS
            // Replace track
            // console.log(`stream canvas: ${stream}`);
            // $.localStream.replaceTrack(
            //   stream.getVideoTracks()[0],
            //   () => {
            //     console.log("successfully replaced");
            //   },
            //   (err) => {
            //     console.log(`error replacing: ${err}`);
            //   }
            // );
            $.addStream($.localStream, true);
            $.client.publish($.localStream, (err) => {
              console.log("Publish local stream error: " + err);
            });
            jquery(window).on("beforeunload", function() {
              return "Are you sure you want to leave?";
            });
            $.showControls();
            $.startLiveTranscoding();
            $.$store.state.showScreenShareButtonForOthers = true;
            $.isHandRaised = false;
            $.readyState = true;
            // $.$root.$emit("submitSetting");
          },
          (err) => {
            console.log("getUserMedia failed", err);
            $.readyState = true;
          }
        );
      }
    },
    handleHostResponse(req, userData) {
      const $ = this;
      if (req.accept === true && req.decline === false) {
        // add stream to the view
        // check for both host as well as audience
        // console.log("handleHostResponse -> playUserStream: ", userData.uid);
        $.$root.$emit("playUserStream", userData.uid);
        $.isShowLeave();
        if ($.handRequest.length > 0) {
          $.handRequest.forEach((item, i) => {
            if (item == userData.uid) {
              $.handRequest.splice(i, 1);
            }
          });
        }
      } else if (req.decline === true && req.accept === false) {
        if ($.handRequest.length > 0) {
          $.handRequest.forEach((item, i) => {
            if (item == userData.uid) {
              $.handRequest.splice(i, 1);
            }
          });
        }
        $.$root.$emit("pleaseHandleDeclineByHost", userData.uid);
      }
    },
    handleReaction(emojiId) {
      //code to handle Reaction
      const $ = this;
      $.$root.$emit("handleEventReaction", emojiId);
      $.showReactionAnimation(emojiId);
      let data = {
        channel_id: $.$route.params.session,
        type: emojiId,
      };
      $.$store.dispatch("storeEventReaction", data).then((resp) => {
        if (resp.data.status === "success") {
          $.reaction = resp.data.data;
          $.$root.$emit("emojiCounter", resp.data.data);
        }
      });
    },
    showReactionAnimation(emojiId) {
      let se = document.getElementById("showEmoji");
      clearInterval(intervalId);
      se.style.transition = "2s all ease";
      se.style.position = "absolute";
      se.style.bottom = "50px";
      intervalId = setInterval(bubbleUpEmoji, 50);
      function bubbleUpEmoji() {
        let spanEl = document.createElement("div");
        let imgEl = document.createElement("img");
        if (emojiId === "heart") {
          imgEl.src = require("../../assets/heart.svg");
          imgEl.alt = "Heart";
        } else if (emojiId === "clap") {
          imgEl.src = require("../../assets/clap.svg");
          imgEl.alt = "Clap";
        } else if (emojiId === "thumb") {
          imgEl.src = require("../../assets/thumb.svg");
          imgEl.alt = "thumb";
        } else {
          imgEl.src = require("../../assets/laugh.svg");
          imgEl.alt = "Laugh";
        }
        spanEl.appendChild(imgEl);
        spanEl.style.transition = "2s all ease";
        spanEl.style.animation = "emoji 3.5s infinite";
        spanEl.style.transition = "translateY(100px)";
        // Timeout for fading
        setTimeout(function() {
          spanEl.style.transition = "2s all ease";
          spanEl.style.opacity = 0;
          // spanEl.remove();
          setTimeout(function() {
            spanEl.remove();
          }, 2000);
        }, 2000);
        se.style.opacity = 1;
        // let randPos = Math.round(Math.random() * 55);
        let randPos = 5.5;
        // To shift emoji left or right
        let leftOrRight = Math.round(Math.random() * 1);
        let plusMinus = Math.round(Math.random() * 1);
        if (leftOrRight === 0) {
          if (plusMinus === 0) {
            spanEl.style.marginLeft = `${randPos}px`;
            // spanEl.style.fontSize = "16px";
            imgEl.style.width = "30px";
            imgEl.style.height = "30px";
            spanEl.style.opacity = ".7";
          } else {
            spanEl.style.marginLeft = `-${randPos}px`;
            // spanEl.style.fontSize = "24px";
            imgEl.style.width = "45px";
            imgEl.style.height = "45px";
            spanEl.style.opacity = ".9";
          }
        } else {
          spanEl.style.transition = "2s all ease";
          if (plusMinus === 0) {
            spanEl.style.marginLeft = `${randPos}px`;
            // spanEl.style.fontSize = "12px";
            imgEl.style.width = "15px";
            imgEl.style.height = "15px";
            spanEl.style.opacity = "1";
          } else {
            spanEl.style.marginLeft = `-${randPos}px`;
            // spanEl.style.fontSize = "20px";
            imgEl.style.width = "40px";
            imgEl.style.height = "40px";
            spanEl.style.opacity = ".8";
          }
        }
        // spanEl.style.transform = "translateY(-420px)";
        se.appendChild(spanEl);
        clearInterval(intervalId);
        // if (counter > 30) spanEl.style.opacity = ".8";
        // if (counter > 50) spanEl.style.opacity = ".6";
        // if (counter >= 50) spanEl.style.opacity = "0";
      }
    },
    toggle() {
      this.fullscreen.toggle(this.$el.querySelector("#ag-canvas"), {
        wrap: false,
        callback: this.fullscreenChange,
      });
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    },
    sendUidToParent: function() {
      this.$emit("getUid", this.uid.toString());
    },
    streamInit(uid, attendeeMode, videoProfile, config) {
      // videoProfile, config - not being used
      let defaultConfig = {
        streamID: uid,
        audio: true,
        video: true,
        screen: false,
        cameraId: this.$store.state.cameraId,
        microphoneId: this.$store.state.microphoneId,
        mirror: true,
      };
      switch (attendeeMode) {
        case "screenshare":
          defaultConfig.audio = false;
          defaultConfig.video = false;
          defaultConfig.screen = true;
          // defaultConfig.screenAudio = true;
          break;
        case "audio-only":
          defaultConfig.video = false;
          break;
        case "audience":
          defaultConfig.video = false;
          defaultConfig.audio = false;
          break;
        case "video":
          break;
        default:
          break;
      }
      let stream = AgoraRTC.createStream(merge(defaultConfig, config));
      // stream.setVideoProfile("480p");
      stream.setVideoProfile("480p_4");
      return stream;
    },
    subscribeStreamEvents() {
      let rt = this;
      rt.client.on("peer-online", (evt) => {
        // console.log("peer-online", evt.uid);
        if (evt.uid === 10000320) {
          rt.isScreenBeingSharedByRemote = true;
        } else if (evt.uid === 666) {
          rt.isSharingExternalVideo = true;
        }
      });
      rt.client.on("connection-state-change", () => {
        if (rt.attendeeMode === "host") {
          rt.streamList.length = 0;
          rt.$root.$emit("pleaseemptylocalstream");
        }
      });
      rt.client.on("mute-audio", (evt) => {
        const $ = this;
        $.handleMuteAudio(evt.uid);
      });
      rt.client.on("unmute-audio", (evt) => {
        const $ = this;
        $.handleUnmuteAudio(evt.uid);
      });
      rt.client.on("mute-video", (evt) => {
        const $ = this;
        $.$store.memberList.map((user) => {
          if (user.uid === evt.uid) {
            let targetElement = document.getElementById(`player_${evt.uid}`);
            var img = document.createElement("img");
            img.src = `${user.photoURL}`;
            img.style.position = "absolute";
            img.setAttribute("id", "user_photo");
            img.style.top = "50%";
            img.style.left = "50%";
            img.style.transform = "translate(-50%, -50%)";
            targetElement.appendChild(img);
          }
        });
        $.handleMuteVideo(evt.uid);
      });
      rt.client.on("unmute-video", (evt) => {
        const $ = this;
        let userPhoto = document.getElementById(`user_photo`);
        userPhoto.remove();
        jquery(`#video${evt.uid}`).show();
        $.handleUnmuteVideo(evt.uid);
      });
      rt.client.on("stream-published", function(evt) {
        let localStream = evt.stream;
        rt.addStream(localStream, true);
      });
      rt.client.on("streamInjectedStatus", () => {
        // console.log("Streamssssss injected");
      });
      rt.client.on("stream-added", function(evt) {
        let remoteStream = evt.stream;
        // console.log("Remote stream Id: " + remoteStream.getId());
        rt.$store.memberList.forEach((member) => {
          if (member.uid === remoteStream.getId()) {
            rt.$toast.open({
              message: `Welcome to the stage, ${member.name}`,
              type: "info",
              position: "top",
              queue: true,
            });
          }
        });

        rt.client.subscribe(remoteStream, function(err) {
          console.log("Subscribe stream failed", err);
        });
      });
      // Playing the remote stream after sunscribing to it
      rt.client.on("stream-subscribed", function(evt) {
        let remoteStream = evt.stream;
        rt.addStream(remoteStream, true);

        if (rt.isScreenBeingSharedByRemote || rt.isSharingExternalVideo) {
          if (document.querySelector(`video-info-${remoteStream.getId()}`)) {
            document.querySelector(
              `video-info-${remoteStream.getId()}`
            ).style.bottom = "0px";
            document.querySelector(
              `video-info-${remoteStream.getId()}`
            ).style.height = "27px";
          }
        }
      });
      // When remote user leave
      rt.client.on("peer-leave", function(evt) {
        // console.log("Peer has left: " + evt.uid);
        // console.log(new Date().toLocaleTimeString());
        console.log(evt);
        rt.removeStream(evt.uid);
        rt.canvasLayout();
        rt.$store.state.streamCount = rt.streamList.length;
      });
      rt.client.on("network-quality", function(stats) {
        // console.log("downlinkNetworkQuality", stats.downlinkNetworkQuality);
        // console.log("uplinkNetworkQuality", stats.uplinkNetworkQuality);
        if (stats.uplinkNetworkQuality === 0) {
          rt.connectionCounter = 0;
          // rt.$toast.open({
          //   message: `Unknown connection`,
          //   type: "info",
          //   position: "top",
          // });
        } else if (stats.uplinkNetworkQuality === 1) {
          rt.connectionCounter = 0;
          // rt.$toast.open({
          //   message: "Excellent connection",
          //   type: "info",
          //   position: "top",
          // });
        } else if (stats.uplinkNetworkQuality === 2) {
          rt.connectionCounter = 0;
          // rt.$toast.open({
          //   message: `Good connection`,
          //   type: "info",
          //   position: "top",
          // });
        } else if (
          stats.uplinkNetworkQuality === 3 &&
          stats.downlinkNetworkQuality === 3
        ) {
          rt.connectionCounter = 0;
          rt.$toast.open({
            message: `Weak connection`,
            type: "info",
            position: "top",
            queue: true,
          });
        } else if (
          stats.uplinkNetworkQuality === 4 &&
          stats.downlinkNetworkQuality === 4
        ) {
          rt.connectionCounter = 0;
          rt.$toast.open({
            message: `The connections seems unstable.`,
            type: "info",
            position: "top",
            queue: true,
          });
          rt.$root.$emit("unstableConnection");
        } else if (
          stats.uplinkNetworkQuality === 5 &&
          stats.downlinkNetworkQuality === 5
        ) {
          if (rt.connectionCounter === 6) {
            rt.$toast.open({
              message: `Bad connection`,
              type: "info",
              position: "top",
              queue: true,
            });
            rt.handlePoorConnection();
          }
          rt.connectionCounter++;
        } else if (
          stats.uplinkNetworkQuality === 6 &&
          stats.downlinkNetworkQuality === 6
        ) {
          if (rt.connectionCounter === 6) {
            rt.$toast.open({
              message: `No connection`,
              type: "info",
              position: "top",
              queue: true,
            });
            rt.handlePoorConnection();
          }
          rt.connectionCounter++;
        }
      });
      // Remote stream is removed
      rt.client.on("stream-removed", function(evt) {
        let stream = evt.stream;
        // console.log("Conditionss: " + condition);
        // console.log("Stream removed: " + stream.getId());

        rt.removeStream(stream.getId());
        rt.canvasLayout();
        rt.$store.memberList.forEach((member) => {
          if (member.uid === stream.getId()) {
            rt.$toast.open({
              message: `${member.name} left the stage`,
              type: "info",
              position: "top",
              queue: true,
            });
          }
        });
      });
      //live transcoding events..
      rt.client.on("liveStreamingStarted", function(evt) {
        console.log("Live streaming started", evt);
      });

      rt.client.on("liveStreamingFailed", function(evt) {
        console.log("Live streaming failed", evt);
      });

      rt.client.on("liveStreamingStopped", function(evt) {
        console.log("Live streaming stopped", evt);
      });

      rt.client.on("liveTranscodingUpdated", function(evt) {
        console.log("Live streaming updated", evt);
      });
    },
    // Remove remote stream
    removeStream(uid) {
      const $ = this;
      // console.log("Stream: ", $.streamList);

      $.streamList.map((item, index) => {
        if (item.getId() == uid) {
          item.close();
          let element = document.querySelector("#ag-item-" + uid);
          if (element) {
            element.parentNode.removeChild(element);
          }
          let tempList = [...$.streamList];
          tempList.splice(index, 1);
          // steamlist
          $.streamList = tempList;
          $.$store.state.streamCount = $.streamList.length;
        }
      });
      let data = {
        cname: this.channel,
        channel_id: this.$route.params.session,
        appId: this.appID,
        uid: this.uid,
        recordingId: 0,
      };
      this.$store.dispatch("updateEventLayoutRecording", data).then((resp) => {
        if (resp.status === 200) {
          // Acquire and Start recording
          console.log("update rec screen resp");
          // this.$store.state.sid = resp.data.sid;
        } else {
          this.$toast.open({
            message: "Unable to add new video in recording !",
            type: "error",
            position: "bottom",
            queue: true,
          });
        }
      });

      // $.canvasLayout();
      // console.log("stream key on remove: ", $.$store.state.streamKey);
      if (
        $.$store.state.streamKey != "" ||
        $.$store.state.youtubeStreamKey != ""
      ) {
        let transcodingUsersResult = $.liveLayout();
        var configRtmp = {
          width: 1920,
          height: 1080,
          videoBitrate: 2080,
          videoFramerate: 15,
          audioSampleRate: AgoraRTC.AUDIO_SAMPLE_RATE_48000,
          audioBitrate: 48,
          audioChannels: 1,
          videoGop: 30,
          videoCodecProfile: 100,
          userCount: 1,
          backgroundColor: 0,
          transcodingUsers: transcodingUsersResult,
        };
        // set live transcoding config
        this.client.setLiveTranscoding(configRtmp).then((res) => {
          console.log("setLiveConfig for remote streams: ", res);
        });
      }
    },
    // Add stream to the streamList Array
    addStream(stream) {
      //matching whether stream is present in streamList or not
      const $ = this;

      let repeatition = this.streamList.some((item) => {
        return item.getId() == stream.getId();
      });
      if (repeatition) {
        return;
      }
      stream.preloadEffect(
        1,
        "https://meetbeans-data.s3.ap-south-1.amazonaws.com/enter2.wav",
        function(err) {
          if (err) {
            console.error("Failed to preload effect, reason: ", err);
          } else {
            console.log("Effect is preloaded successfully");
            stream.setEffectsVolume(10, function(err) {
              if (err) {
                console.error("Failed to set effects volume, reason: ", err);
              } else {
                console.log("Effects volume is set successfully");

                stream.playEffect(
                  {
                    soundId: 1,
                    filePath:
                      "https://meetbeans-data.s3.ap-south-1.amazonaws.com/enter2.wav",
                  },
                  function(err) {
                    if (err) {
                      console.log("audio error");
                    }
                  }
                );
              }
            });
          }
        }
      );
      //  this.streamList = this.streamList.concat([stream]);
      if ($.streamList.length < 17) {
        this.streamList = this.streamList.concat([stream]);
        // if (stream.getId() == $.remoteScreenShareUid) {
        //   const element = document.querySelector("#ag-item-" + stream.getId());
        //   element.setAttribute("class", "display-screen");
        // }
        let no = $.streamList.length;
        if (no > 0) {
          $.streamList.map((item) => {
            let id = item.getId();
            let canvas = document.querySelector("#screen-share-panel");

            let dom = document.querySelector("#ag-item-" + id);

            if (!dom) {
              dom = document.createElement("section");
              dom.setAttribute("id", "ag-item-" + id);
              dom.setAttribute("class", "ag-item");
              canvas.appendChild(dom);
              if ($.isSharingVideo && id === 10000321) {
                const video = jquery("#liveVideo")[0];
                // console.log("Videotrack", video);

                video.load();
                video.play();
                const videoStream = video.captureStream(60);
                item.replaceTrack(videoStream.getVideoTracks()[0]);

                // $.isSharingVideo = false
                item.play("ag-item-" + id, { fit: "contain" });
              } else if (id === 10000320 || id === 666) {
                canvas = document.querySelector("#ag-canvas");
                canvas.appendChild(dom);
                item.play("ag-item-" + id, { fit: "contain" });
              } else {
                item.play("ag-item-" + id);
              }
            }
            // console.log("is being shared: ", $.isScreenBeingSharedByRemote);

            if (
              $.isScreenBeingSharedByRemote ||
              $.isSharingExternalVideo ||
              $.isSharingVideo
            ) {
              let bc = document.querySelector("#ag-canvas");
              bc.setAttribute(
                "style",
                `display:flex; flex-wrap: wrap; flex-direction: row-reverse;overflow: hidden`
              );

              let panel = document.querySelector("#screen-share-panel");
              panel.setAttribute(
                "style",
                `display: flex;flex-direction: column;width: 15%; height: 85vh;  z-index: 11;`
              );
              if (id !== 10000320 || id !== 666) {
                if ($.streamList.length < 8) {
                  dom.setAttribute(
                    "style",
                    `padding: 2px;width: 100%;height: 15vh`
                  );
                } else {
                  dom.setAttribute(
                    "style",
                    `padding: 2px;width: 50%;height: 10.62vh`
                  );
                }
              } else {
                dom.setAttribute(
                  "style",
                  `padding: 2px;width: 100%;height: 85vh`
                );
              }
            } else {
              if (length == 1) {
                dom.setAttribute(
                  "style",
                  `padding: 2px;width: 100%;height: 85vh`
                );
              } else if (length == 2) {
                dom.setAttribute(
                  "style",
                  `padding: 2px;width: 50%;height: 85vh`
                );
              } else if (length >= 3 && length < 5) {
                dom.setAttribute(
                  "style",
                  `padding: 2px;width: 50%;height: 42.5vh`
                );
              } else if (length >= 5 && length < 7) {
                dom.setAttribute(
                  "style",
                  `padding: 2px;width: 33.3%;height: 42.5vh`
                );
              } else if (length >= 7 && length < 13) {
                dom.setAttribute(
                  "style",
                  `padding: 2px;width: 25%;height: 21.25vh`
                );
              } else if (length >= 13 && length < 18) {
                dom.setAttribute(
                  "style",
                  `padding: 2px;width: 20%;height: 21.25vh`
                );
              }
            }
            if (
              $.$store.state.streamKey != "" ||
              $.$store.state.youtubeStreamKey != ""
            ) {
              let transcodingUsersResult = $.liveLayout();
              var configRtmp = {
                width: 1920,
                height: 1080,
                videoBitrate: 2080,
                videoFramerate: 15,
                audioSampleRate: AgoraRTC.AUDIO_SAMPLE_RATE_48000,
                audioBitrate: 48,
                audioChannels: 1,
                videoGop: 30,
                videoCodecProfile: 100,
                userCount: 1,
                backgroundColor: 0,
                transcodingUsers: transcodingUsersResult,
              };
              // set live transcoding config
              this.client.setLiveTranscoding(configRtmp).then((res) => {
                console.log("setLiveConfig for remote streams: ", res);
                // this.client
                //   .startLiveStreaming(
                //     `${this.facebookStreamUrl}/${this.$store.state.streamKey}`,
                //     true
                //   )
                //   .then((success) => console.log("startLive: ", success))
                //   .catch((err) => console.log("live streaming error: ", err));
              });
            }

            // item.player.resize && item.player.resize();
            if (document.querySelector(`ag-item-${id}`) === null) {
              jquery(`ag-item-${id}`).remove();
              $.canvasLayout();
            }
            $.canvasLayout();
            setTimeout(function() {
              if (document.querySelector("#ag-item-" + id)) {
                const videoInfo = jquery("#video-info-" + id);
                // console.log("vs video length : ", videoInfo);
                if (videoInfo.length <= 1) {
                  // console.log("handle video length vs:  ", videoInfo.length);
                  $.handleVideoInfo(item);
                }
                document.querySelector(".ag-item").style.padding = "2px";
              }
            }, 1000);

            // setInterval(function() {
            //   var audioLevel = "";
            //   if(item.getId() !== 10000320 || item.getId() !== 1000000001){
            //     audioLevel = stream.getAudioLevel();
            //     // Use audioLevel to render the UI
            //     if(document.getElementsByClassName(`left-audio-indicator-${item.getId()}`)[0]){
            //       let commonAudioIndicator = document.getElementsByClassName(`left-audio-indicator-${item.getId()}`)[0];
            //       commonAudioIndicator.style.height = `${audioLevel+Math.random().toFixed(2)}rem`;
            //     }
            //     if(document.getElementsByClassName(`right-audio-indicator-${item.getId()}`)[0]) {
            //       let commonAudioIndicator1 = document.getElementsByClassName(`right-audio-indicator-${item.getId()}`)[0];
            //       commonAudioIndicator1.style.height = `${audioLevel+Math.random().toFixed(2)}rem`;
            //     }
            //     if(document.getElementsByClassName(`main-audio-indicator-${item.getId()}`)[0]) {
            //       let mainAudioIndicator = document.getElementsByClassName(`main-audio-indicator-${item.getId()}`)[0];
            //       mainAudioIndicator.style.height = `${audioLevel+Math.random().toFixed(2)}rem`;
            //     }
            //     // console.log(`${item.getId()} ${audioLevel.toFixed(2)}rem`)
            //   }
            // }, 200);
          });
        }
      } else {
        this.$toast.open({
          message: "Not allowed more than 17 participants.",
          type: "info",
          position: "top",
          queue: true,
        });
      }
      this.$store.state.streamCount = this.streamList.length;
      if ($.attendeeMode !== "host") {
        let shareId = this.streamList.some((item) => {
          return item.getId() == "10000320";
        });
        let ID = shareId ? 10000320 : 0;
        let data = {
          cname: this.channel,
          channel_id: this.$route.params.session,
          appId: this.appID,
          uid: this.uid,
          recordingId: ID,
        };

        this.$store
          .dispatch("updateEventLayoutRecording", data)
          .then((resp) => {
            if (resp.status === 200) {
              // Acquire and Start recording
              console.log("update rec screen resp");
              // this.$store.state.sid = resp.data.sid;
            } else {
              this.$toast.open({
                message: "Unable to add new video in recording !",
                type: "error",
                position: "bottom",
                queue: true,
              });
            }
          });
      }
    },
    handleCamera(e) {
      e.currentTarget.classList.toggle("off");
      if (this.localStream.isVideoOn()) {
        this.$toast.open({
          message: "Video is disable",
          type: "info",
          position: "bottom",
          queue: true,
        });
        this.localStream.muteVideo();
        // this.videoCalllocalStream.disableVideo();
        // console.log("USERINFO: ", this.user);
        // console.log("STREAMS: ", this.streamList);
        // console.log("USERINFO: ", localStorage.getItem("user_info"));
        let user_info = JSON.parse(localStorage.getItem("user_info"));
        // console.log("USER_INFO: ", user_info);
        let targetElement = document.getElementById(`player_${user_info.uid}`);
        // jquery(`#video${user_info.uid}`).hide();
        var img = document.createElement("img");
        img.src = `${user_info.photoURL}`;
        img.style.position = "absolute";
        img.setAttribute("id", "user_photo_client");
        img.style.top = "50%";
        img.style.left = "50%";
        img.style.transform = "translate(-50%, -50%)";
        targetElement.appendChild(img);
      } else {
        this.$toast.open({
          message: "Video is enable",
          type: "success",
          position: "bottom",
          queue: true,
        });
        let userPhoto = document.getElementById(`user_photo_client`);
        userPhoto.remove();
        this.localStream.unmuteVideo();
        // jquery(`#video${this.user.uid}`).show();
      }
      // e.currentTarget.classList.toggle("off");
      // if (this.localStream.isVideoOn()) {
      //   this.$toast.open({
      //     message: "Video is disable",
      //     type: "info",
      //     position: "bottom",
      //   });
      //   this.localStream.muteVideo();
      //   let targetElement = document.getElementById(`player_${this.user.uid}`);
      //   jquery(`#video${this.user.uid}`).hide();
      //   var img = document.createElement('img');
      //   img.src = `${this.user.photoURL}`;
      //   img.style.position = 'absolute';
      //   img.setAttribute('id', 'user_photo')
      //   img.style.top = '50%'
      //   img.style.left = '50%'
      //   img.style.transform = 'translate(-50%, -50%)'
      //   img.style.width = '80%'
      //   targetElement.appendChild(img)
      // } else {
      //   this.$toast.open({
      //     message: "Video is enable",
      //     type: "success",
      //     position: "bottom",
      //   });
      //   this.localStream.unmuteVideo();
      //   let userPhoto = document.getElementById(`user_photo`);
      //   userPhoto.remove()
      //   jquery(`#video${this.user.uid}`).show();
      // }
    },
    handleMic(e) {
      e.currentTarget.classList.toggle("off");
      if (this.localStream.isAudioOn()) {
        this.$toast.open({
          message: "Mute",
          type: "info",
          position: "bottom",
          queue: true,
        });
        this.localStream.disableAudio();
      } else {
        this.$toast.open({
          message: "Unmute",
          type: "success",
          position: "bottom",
          queue: true,
        });
        this.localStream.enableAudio();
      }
    },
    handleRec(e) {
      e.currentTarget.classList.toggle("off");
      if (
        document.querySelector(".recordingControlBtn").classList.contains("off")
      ) {
        this.startRecording();
        this.$toast.open({
          message: "Recording Started",
          type: "info",
          position: "top",
          duration: 500,
          queue: true,
        });
      } else {
        this.stopRecording();
        this.$toast.open({
          message: "Recording Stopped",
          type: "info",
          position: "top",
          duration: 500,
          queue: true,
        });
      }
    },
    startRecording() {
      let data = {
        cname: this.channel,
        channel_id: this.$route.params.session,
        appId: this.appID,
        uid: this.uid,
      };

      this.$store.dispatch("getEventRecordingToken", data).then((resp) => {
        if (resp.status == "success") {
          this.$store.state.recordingUid = resp.data.uid;
          this.$store.state.recordingToken = resp.data.recording_token;
          // Acquire and Start recording
          console.log(resp);
          this.$store
            .dispatch("getEventRecordingResourceId", data)
            .then((resp) => {
              if (resp.status === 200) {
                // Acquire and Start recording
                console.log("acquire: ", resp);
                this.$store.state.resourceId = resp.data.resourceId;
                this.$store
                  .dispatch("startEventRecording", data)
                  .then((resp) => {
                    if (resp.status === 200) {
                      // Acquire and Start recording
                      // console.log('start rec resp: ', resp);
                      this.$store.state.sid = resp.data.sid;
                      this.$store
                        .dispatch("storeEventSid", {
                          sid: this.$store.state.sid,
                          session_id: this.$route.params.session,
                        })
                        .then((resp) => {
                          if (resp.status === 200) {
                            console.log("live api stored");
                          }
                        });

                      this.$store
                        .dispatch("queryEventRecording", data)
                        .then((resp) => {
                          if (resp.status === 200) {
                            // Acquire and Start recording
                            console.log("query rec resp: ", resp);
                            this.$store
                              .dispatch("updateEventLayoutRecording", data)
                              .then((resp) => {
                                if (resp.status === 200) {
                                  // Acquire and Start recording
                                  console.log("update rec resp: ", resp);
                                  document.querySelector(
                                    "#liveRecordingTimer"
                                  ).style.display = "flex";
                                  //  Time for cloud recording
                                  try {
                                    timer.start();
                                    //  Timer for recording
                                    timer.addEventListener(
                                      "secondsUpdated",
                                      function() {
                                        jquery("#timer").html(
                                          timer.getTimeValues().toString()
                                        );
                                      }
                                    );
                                  } catch (e) {
                                    console.error("Timer error exception: ", e);
                                  }
                                } else {
                                  this.$toast.open({
                                    message:
                                      "Unable to record video, please try again !",
                                    type: "error",
                                    position: "bottom",
                                    queue: true,
                                  });
                                }
                              });
                          }
                        });
                    } else {
                      this.$toast.open({
                        message: "Unable to record video, please try again !",
                        type: "error",
                        position: "bottom",
                        queue: true,
                      });
                    }
                  });
              } else {
                this.$toast.open({
                  message: "Unable to record video, please try again !",
                  type: "error",
                  position: "bottom",
                  queue: true,
                });
              }
            });
        } else {
          this.$toast.open({
            message: "Unable to record video, please try again !",
            type: "error",
            position: "bottom",
            queue: true,
          });
        }
      });
    },
    switchDisplay(e) {
      if (
        e.currentTarget.classList.contains("disabled") ||
        this.streamList.length <= 1
      ) {
        return;
      }
      if (this.displayMode === "pip") {
        this.displayMode = "tile";
      } else if (this.displayMode === "tile") {
        this.displayMode = "pip";
      } else if (this.displayMode === "share") {
        // do nothing or alert, tbd
      } else {
        console.error("Display Mode can only be tile/pip/share");
      }
    },
    hideRemote(e) {
      if (
        e.currentTarget.classList.contains("disabled") ||
        this.streamList.length <= 1
      ) {
        return;
      }
      let list;
      let id = this.streamList[this.streamList.length - 1].getId();
      list = Array.from(
        document.querySelectorAll(`.ag-item:not(#ag-item-${id})`)
      );
      list.map((item) => {
        if (item.style.display !== "none") {
          item.style.display = "none";
        } else {
          item.style.display = "block";
        }
      });
    },
    async playVideoFromCamera() {
      try {
        const constraints = {
          video: {
            deviceId: this.$store.state.cameraId,
            frameRate: { ideal: 15, max: 15 },
          },
        };
        const stream = await navigator.mediaDevices.getUserMedia(constraints);
        const videoElement = document.querySelector("video#localVideo");
        videoElement.srcObject = stream;
      } catch (error) {
        console.error("Error opening video camera.", error);
      }
    },
    addCanvas() {
      const $ = this;
      // console.log('canvas id: ', streamId)
      // console.log("called add canvas");
      let canvas = document.createElement("canvas");
      canvas.id = "canvaslocal";
      canvas.style.display = "none";
      canvas.style.background = "green";
      document.querySelector("#ag-canvas").appendChild(canvas);
      // console.log("added canvas");
      let ctx = canvas.getContext("2d");
      let video = document.querySelector("#localVideo");
      video.pause();
      video.play();
      video.addEventListener("loadedmetadata", function() {
        // console.log('width & height: ', video.videoWidth, video.videoHeight)
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
      });

      canvas.width = 640;
      canvas.height = 480;
      const user = JSON.parse(localStorage.getItem("user_info"));
      // video.style.visibility = "hidden";
      video.addEventListener(
        "play",
        function() {
          var $this = this; //cache
          (function loop() {
            let x = 0,
              y = 0,
              txt = 10,
              subTxt = 8.5;
            if ($.streamList.length == 1) {
              y = 380;
              x = 10;
            } else if ($.streamList.length >= 2) {
              y = 380;
              x = 40;
              txt = 13;
              subTxt = 9.5;
            }
            if (!$this.paused && !$this.ended) {
              ctx.drawImage($this, 0, 0);
              // $.roundRect(ctx, 10, 10, 140, 48, 5, true);
              if (
                $.isScreenBeingSharedByRemote &&
                ($.isScreenShare || $.isActiveScreenShare)
              ) {
                y = 420;
                x = 10;
                txt = 55;
                ctx.fillStyle = "#000";
                ctx.globalAlpha = 0.75;
                ctx.fillRect(x, y - 40, 500, 160);
                ctx.globalAlpha = 1.0;
                ctx.fillStyle = "#FFB229";
                ctx.font = `${txt}px Arial`;
                ctx.fillText(`${user.name}`, 20 + x, 18 + y);
                ctx.globalAlpha = 1.0;
                ctx.fillStyle = "#FFF";
                ctx.font = `${subTxt}px Arial`;
              } else {
                ctx.fillStyle = "#000";
                ctx.globalAlpha = 0.75;
                ctx.fillRect(x, y, 120, 48);
                ctx.globalAlpha = 1.0;
                ctx.fillStyle = "#FFB229";
                ctx.font = `${txt}px Arial`;
                ctx.fillText(`${user.name}`, 20 + x, 18 + y);
                ctx.globalAlpha = 1.0;
                ctx.fillStyle = "#FFF";
                ctx.font = `${subTxt}px Arial`;
                ctx.fillText(
                  `${user.designation}, ${user.company}`,
                  20 + x,
                  36 + y
                );
              }
              setTimeout(loop, 1000 / 15); // drawing at 15fps
            }
          })();
        },
        0
      );
    },
    roundRect(ctx, x, y, width, height, radius, fill, stroke) {
      if (typeof stroke === "undefined") {
        stroke = true;
      }
      if (typeof radius === "undefined") {
        radius = 5;
      }
      if (typeof radius === "number") {
        radius = { tl: radius, tr: radius, br: radius, bl: radius };
      } else {
        var defaultRadius = { tl: 0, tr: 0, br: 0, bl: 0 };
        for (var side in defaultRadius) {
          radius[side] = radius[side] || defaultRadius[side];
        }
      }
      ctx.beginPath();
      ctx.moveTo(x + radius.tl, y);
      ctx.lineTo(x + width - radius.tr, y);
      ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
      ctx.lineTo(x + width, y + height - radius.br);
      ctx.quadraticCurveTo(
        x + width,
        y + height,
        x + width - radius.br,
        y + height
      );
      ctx.lineTo(x + radius.bl, y + height);
      ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
      ctx.lineTo(x, y + radius.tl);
      ctx.quadraticCurveTo(x, y, x + radius.tl, y);
      ctx.closePath();
      if (fill) {
        ctx.fillStyle = "#000";
        ctx.globalAlpha = 0.75;
      }
      if (stroke) {
        ctx.stroke();
      }
    },
    handleClient() {
      const $ = this;

      // $.playVideoFromCamera();

      // client initialization
      $.client = AgoraRTC.createClient({ mode: $.mode, codec: $.codec });
      $.client.init($.appID, () => {
        $.subscribeStreamEvents();
        // console.log("role: ", $.$store.state.role);
        // if ($.$store.state.role === "speaker") {
        //   $.client.setClientRole("audience", function(e) {
        //     if (!e) {
        //       console.log("setHost success", $.attendeeMode);
        //     } else {
        //       console.log("setHost error", e);
        //     }
        //   });
        // } else {
        //   $.client.setClientRole($.attendeeMode, function(e) {
        //     if (!e) {
        //       console.log("setHost success", $.attendeeMode);
        //     } else {
        //       console.log("setHost error", e);
        //     }
        //   });
        // }
        // client join
        $.client.join($.token, $.channel, $.uid, (uid) => {
          // enabling dual stream to minimize bandwidth consumption and ensure smooth communication in a video scenario with multiple users
          $.client.enableDualStream(
            () => {
              $.uid = uid;
              // If no parameter are passed default values are used (bitrate : 50kbps, resolution: 160*120, framerate: 15 fps)
              // $.client.setLowStreamParameter();

              $.localStreamUidList.push(uid);
              if ($.uid !== null) {
                $.sendUidToParent();
              }

              // create local stream
              $.localStream = $.streamInit(
                $.uid,
                $.attendeeMode,
                $.videoProfile,
                $.config
              );
              // console.log($.attendeeMode);
              $.localStream.init(
                () => {
                  // const user = JSON.parse(localStorage.getItem("user_info"));
                  // console.log("attendee: ", $.attendeeMode);
                  if (
                    $.attendeeMode !== "audience" &&
                    $.attendeeMode !== "speaker"
                  ) {
                    // $.addCanvas();
                    // Find the canvas element to capture
                    // var canvasElt = document.querySelector("#canvaslocal");

                    // Get the stream
                    // var stream = canvasElt.captureStream(15); // 15 FPS
                    // Replace track
                    // console.log(`stream canvas: ${stream}`);
                    // $.localStream.replaceTrack(
                    //   stream.getVideoTracks()[0],
                    //   () => {
                    //     console.log("successfully replaced");
                    //   },
                    //   (err) => {
                    //     console.log(`error replacing: ${err}`);
                    //   }
                    // );

                    $.addStream($.localStream, true);
                    $.$toast.open({
                      message: "You are live.",
                      type: "success",
                      position: "top",
                      duration: 500,
                      queue: true,
                    });

                    $.client.publish($.localStream, (err) => {
                      console.log("Publish local stream error: " + err);
                    });

                    $.showControls();
                    $.$root.$emit("startSession", $.uid);
                    setTimeout(() => {
                      if ($.attendeeMode === "host") {
                        $.startLiveTranscoding();
                      }
                    }, 2000);
                    // $.$root.$emit("getAudience");
                    // this.startRecording();
                    // $.$root.$emit('submitSetting')
                    // if (!$.$store.state.isSpeaker) {
                    //   jquery(window).on("beforeunload", function() {
                    //     $.handleExit();
                    //     return "Are you sure you want to leave?";
                    //   });
                    // }
                    // jquery(window).on("unload", function() {
                    //   $.handleExit();

                    // });
                  }
                  $.readyState = true;
                },
                (err) => {
                  console.log("getUserMedia failed", err);
                  if (err.info === "Permission denied") {
                    // handle Permission denied case
                  }
                  $.readyState = true;
                }
              );
              // It is not recommended to setState in function addStream
              // $.attendeeMode - "audio-only", "audience", video"
              // $.videoProfile, $.config - passing deafult val ""
              console.log("Screen sharing dual stream");
            },
            (err) => {
              console.log("Screen sharing dual stream error: ", err);
            }
          );
        });
      });
    },
    startLiveTranscoding() {
      let transcodingUsersResult = this.liveLayout();
      console.log("transcoding: ", transcodingUsersResult);
      var configRtmp = {
        width: 1920,
        height: 1080,
        videoBitrate: 2080,
        videoFramerate: 15,
        audioSampleRate: AgoraRTC.AUDIO_SAMPLE_RATE_48000,
        audioBitrate: 48,
        audioChannels: 1,
        videoGop: 30,
        videoCodecProfile: 100,
        userCount: 1,
        backgroundColor: 0,
        images: [
          {
            url:
              "https://meetbeans-data.s3.ap-south-1.amazonaws.com/meetbeans-stream-logo.png",
            x: 1500,
            y: 960,
            width: 400,
            height: 100,
          },
        ],
        transcodingUsers: transcodingUsersResult,
      };
      // set live transcoding config
      this.client.setLiveTranscoding(configRtmp).then((res) => {
        console.log(res);
        if (this.$store.state.youtubeStreamKey !== "") {
          this.client
            .startLiveStreaming(
              `${this.youtubeStreamUrl}/${this.$store.state.youtubeStreamKey}`,
              true
            )
            .then((success) => {
              console.log("startLive: ", success);
              Swal.fire(
                "You are live on YouTube.",
                "Don't forget to click go live on your YouTube live studio.",
                "success"
              );
              this.$store.state.isYoutubeLive = true;
            })
            .catch((err) => {
              console.log("live streaming error: ", err);
              if (
                err.code === 454 &&
                err.reason === "Already exist this stream"
              ) {
                this.$store.state.isYoutubeLive = true;
              } else {
                this.$store.state.isYoutubeLive = false;
              }
            });
        }
        if (this.$store.state.streamKey !== "") {
          this.client
            .startLiveStreaming(
              `${this.facebookStreamUrl}/${this.$store.state.streamKey}`,
              true
            )
            .then((success) => {
              console.log("startLive: ", success);
              this.$store.state.isFacebookLive = true;
              Swal.fire(
                "You are live on Facebook.",
                "Don't forget to click go live on your facebook live studio.",
                "success"
              );
            })
            .catch((err) => {
              console.log("live streaming error: ", err);
              if (
                err.code === 454 &&
                err.reason === "Already exist this stream"
              ) {
                this.$store.state.isFacebookLive = true;
              } else {
                this.$store.state.isFacebookLive = false;
              }
            });
        }
      });
    },
    handleExit() {
      try {
        this.$store.state.isLive = false;
        this.$store.state.isNetworking = true;
        this.$store.state.isBreak = false;
        this.$store.state.isEnd = true;
        this.$store.state.isScreenShare = false;
        this.postMeetingStatus();
        this.$store.state.streamCount = 0;
        this.client && this.client.unpublish(this.localStream);
        this.localStream && this.localStream.close();
        this.client &&
          this.client.leave(
            () => {
              console.log("Client succeed to leave.");
            },
            () => {
              console.log("Client failed to leave.");
            }
          );
        this.streamList = [];
        this.handRequest = [];
        this.$root.$emit("emptyHandRaise");
        // Client will do same operation as break session
        this.$root.$emit("notifyUserOnBreak");
        if (this.streamList.length > 0) {
          this.streamList.forEach((stream) => {
            let obj = document.querySelector("#ag-item-" + stream.getId());
            obj.remove();
          });
        }
        this.streamList = [];
      } finally {
        this.readyState = false;
        this.client = null;
        this.localStream = null;
        this.streamList = [];
        this.handRequest = [];
        this.$root.$emit("hostLeftTheMeet");
        if (this.attendeeMode === "host") {
          this.$route.replace("/");
        }
      }
    },
    isFirefox() {
      return userAgentInfo.browser.name === "Firefox";
    },
    isCompatibleChrome() {
      if (userAgentInfo.browser.name === "Chrome") {
        const major = userAgentInfo.browser.major;
        if (major >= 72) return true;
      }
      return false;
    },
    handleScreenShare() {
      const $ = this;
      // $.$store.state.isScreenShare = true;
      $.isSpeakerLoaderScreen = true;
      $.$store.state.isScreenShare = true;
      $.getScreenShareToken(this.$route.params.session);
      $.isScreenBeingSharedByRemote = true;

      // alert("testing");
      let data = {
        cname: this.channel,
        channel_id: this.$route.params.session,
        appId: this.appID,
        uid: this.uid,
        recordingId: 10000320,
      };
      this.$store.dispatch("updateEventLayoutRecording", data).then((resp) => {
        if (resp.status === 200) {
          // Acquire and Start recording
          console.log("update rec screen resp");
          // this.$store.state.sid = resp.data.sid;
        } else {
          this.$toast.open({
            message: "Unable to record video, please try again !",
            type: "error",
            position: "bottom",
            queue: true,
          });
        }
      });
      console.log("update layout: ", data);
    },
    getScreenShareToken(id) {
      const $ = this;
      let data = {
        channel_id: id,
      };
      this.$store.dispatch("getEventScreenShareToken", data).then((resp) => {
        if (resp.data.status === "success") {
          // console.log("Call this... vs--: ", resp.data);
          $.screenShareUid = resp.data.data.uid;
          $.screenShareToken = resp.data.data.rtc_token;
          $.createScreenShareClient();
        } else {
          this.$toast.open({
            message: resp.data.data,
            type: "error",
            position: "top",
            queue: true,
          });
        }
      });
    },
    createScreenShareClient() {
      const $ = this;
      $.screenShareClient = AgoraRTC.createClient({
        mode: $.mode,
        codec: $.codec,
      });
      $.screenShareClient.init($.appID, () => {
        $.screenShareClient.join(
          $.screenShareToken,
          $.channel,
          $.screenShareUid,
          (uid) => {
            console.log(uid);
            const data = {
              screenShareUid: $.screenShareUid,
              attendeeMode: "screenshare",
              videoProfile: {},
              config: {},
            };
            $.screenShareStream = $.streamInit(
              data.screenShareUid,
              data.attendeeMode,
              data.videoProfile,
              data.config
            );
            $.screenShareStream.init(
              () => {
                // $.displayMode = "share";
                // $.$root.$emit("screenShareLoaderStart");
                $.isActiveScreenShare = true;
                $.$root.$emit(
                  "clientScreenShareStarted",
                  $.screenShareStream.getId()
                );
                $.addStream($.screenShareStream, true);
                $.screenShareClient.publish($.screenShareStream, (err) => {
                  console.log("Publish local stream error: " + err);
                });

                $.isSpeakerLoaderScreen = false;
                setTimeout(() => {
                  $.$root.$emit("screenShareLoaderStop");
                }, 2000);
              },
              (err) => {
                $.$toast.open({
                  message: `${err.info}. Go to settings and allow permissions and reload`,
                  type: `${err.type}`,
                  position: "top",
                  queue: true,
                });
                // console.log("getUserMedia failed", err);
                $.$root.$emit("screenShareLoaderStop");
                $.handleStopScreenShare();
              }
            );
            $.screenShareStream.on("stopScreenSharing", () => {
              // $.removeStream($.screenShareStream.getId());
              $.isActiveScreenShare = false;
              $.isScreenBeingSharedByRemote = false;
              $.handleStopScreenShare();
            });
          },
          (err) => {
            console.log("unable to create dummy client: ", err);
            $.removeStream($.screenShareStream.getId());
          }
        );
      });
    },
    handleStopScreenShare() {
      const $ = this;
      $.isActiveScreenShare = false;
      $.$store.state.isScreenShare = false;
      $.isScreenBeingSharedByRemote = false;
      $.isScreenShareLoaded = false;
      $.handleStopShare();
      let bc = document.querySelector("#ag-canvas");
      bc.setAttribute(
        "style",
        `display:flex; flex-wrap: wrap; flex-direction: row-reverse;overflow: hidden`
      );

      let panel = document.querySelector("#screen-share-panel");
      panel.setAttribute(
        "style",
        `display: flex;flex-direction: column;width: 100%; height: 85vh;  z-index: 9;`
      );
    },
    handleStopShare() {
      const $ = this;
      $.removeStream($.screenShareStream.getId());
      $.screenShareStream.stop();
      $.screenShareStream && $.screenShareStream.close();

      let data = {
        cname: this.channel,
        channel_id: this.$route.params.session,
        appId: this.appID,
        uid: this.uid,
        recordingId: 0,
      };
      if ($.attendeeMode !== "audience") {
        this.$store
          .dispatch("updateEventLayoutRecording", data)
          .then((resp) => {
            if (resp.status === 200) {
              // Acquire and Start recording
              console.log("update rec screen resp");
              // this.$store.state.sid = resp.data.sid;
            } else {
              this.$toast.open({
                message: "Unable to record video, please try again !",
                type: "error",
                position: "bottom",
                queue: true,
              });
            }
          });
        // console.log("update layout: ", data);
      }

      $.screenShareClient &&
        $.screenShareClient.leave(
          () => {
            console.log("Client succeed to leave.");
          },
          () => {
            console.log("Client failed to leave.");
          }
        );
      $.canvasLayout();
      $.$root.$emit("clientScreenShareStopped");
    },
    getReactionFunction() {
      const $ = this;
      let data = {
        channel_id: $.$route.params.session,
      };
      $.$store.dispatch("getEventReaction", data).then((resp) => {
        if (resp.data.status === "success") {
          $.reaction = resp.data.data;
        }
      });
    },
  },
  watch: {
    handRequest() {
      console.log(
        "%c:handRequest array in video call-",
        "background: #ff00dd; color: #00ff00",
        this.handRequest
      );
    },
    streamList() {
      this.streamList.forEach((stream) => {
        console.log(
          "%c:stream list has uid",
          "background: #ff00dd; color: #00ff00",
          stream.getId()
        );
      });
    },
  },
  mounted() {
    // init AgoraRTC local client
    const $ = this;
    // this.$store
    //   .dispatch("getEventStreamKey", { session_id: this.$route.params.session })
    //   .then((result) => {
    //     if (result.status === "success") {
    //       console.log("result: ", result);
    //       this.$store.state.streamKey = result.data.data.facebook_key;
    //       this.$store.state.youtubeStreamKey = result.data.data.youtube_key;
    //     } else {
    //       console.log("result: ", result);
    //     }
    //   });
    $.getAgoraTokenFunction();

    this.$nextTick(() => {
      // add listener to control btn group
      let canvas = document.querySelector("#ag-canvas");
      let btnGroup = document.querySelector(".ag-btn-group");
      if (canvas && btnGroup) {
        canvas.addEventListener("mousemove", () => {
          if (global._toolbarToggle) {
            clearTimeout(global._toolbarToggle);
          }
          btnGroup.classList.add("active");
          global._toolbarToggle = setTimeout(function() {
            btnGroup.classList.remove("active");
          }, 3000);
        });
      }
    });
    // let video = document.querySelector("#localVideo");
    // video.addEventListener("pause", function() {
    //   video.play();
    // });
    $.$root.$on("startChannelLiveStream", () => {
      $.startLiveTranscoding();
    });
    $.$root.$on("unstableConnectionNotify", (data) => {
      console.log(
        `${data}'s connection seems unstable, user might get disconnected`
      );
      $.$toast.open({
        message: `${data}'s connection seems unstable, user might get disconnected`,
        type: "warning",
        position: "top",
        queue: true,
      });
    });
    $.$root.$on("hideHost_1", (data) => {
      $.hiddenUid = data.id;
      if (!data.isHidden) {
        $.handleHideHost();
      } else {
        $.handleUnhideHost();
      }
    });
    $.$root.$on("unhideHost_1", () => {
      $.handleUnhideHost();
    });
    $.$root.$on("screenShareLoaderStarted", () => {
      this.isScreenShareLoaded = true;
    });
    $.$root.$on("screenShareLoaderStopped", () => {
      this.isScreenShareLoaded = false;
    });
    $.$root.$on("goFacebookLive", () => {
      // console.log("Called facebook Live", $.$store.state.streamKey);
      this.startLiveTranscoding();
    });
    $.$root.$on("goYoutubeLive", () => {
      // console.log("Called facebook Live", $.$store.state.streamKey);
      this.startLiveTranscoding();
    });
    $.$root.$on("shareVideoStartedClient", (data) => {
      console.log("called", data);
      $.isSharingVideo = true;

      // $.addStream(data.stream)
      // console.log("After called")
    });
    $.$root.$on("removeShareVideoClient", () => {
      $.isSharingExternalVideo = false;
      $.isScreenShareLoaded = false;
      $.$store.state.isExternalVideoShared = false;
    });
    $.$root.$on("shareVideoClient", () => {
      // console.log("THIS IS CALLED ON CLIENT SIDE");
      $.isSharingExternalVideo = true;
      $.isScreenShareLoaded = true;
      $.$store.state.isExternalVideoShared = true;
      setTimeout(function() {
        $.isScreenShareLoaded = false;
      }, 4000);
    });
    $.$root.$on("emojiCountIncrease", (data) => {
      $.reaction = data;
    });
    $.$root.$on("notifySessionEnd_1", () => {
      document.getElementById("closeModal").click();
    });
    $.$root.$on("stopCamera_1", () => {
      this.$store.state.streamCount = 0;
      this.client && this.client.unpublish(this.localStream);
      this.localStream && this.localStream.close();
      this.client &&
        this.client.leave(
          () => {
            console.log("Client succeed to leave.");
          },
          () => {
            console.log("Client failed to leave.");
          }
        );
      if (this.streamList.length > 0) {
        this.streamList.forEach((stream) => {
          let obj = document.querySelector("#ag-item-" + stream.getId());
          obj.remove();
        });
      }
      this.streamList = [];
      this.readyState = false;
      this.localStream = null;
      this.streamList = [];

      $.stopCamera();
    });
    $.$root.$on("updateVotes_1", (obj) => {
      $.clientPoll.answers.map((answer, index) => {
        answer.votes = obj.answers[index].votes;
      });
      $.polls.map((poll) => {
        if (poll.question === obj.question) {
          poll.answers = obj.answers;
        }
      });
      // console.log("Mounted_polls: ", $.polls);

      // let da = {
      //   channel_id: this.$route.params.session,
      // };
      // this.$store.dispatch("getPolls", da).then((resp) => {
      //   if (resp.data.status === 'success'){
      //     $.polls = resp.data.data
      //   }
      // });

      // console.log("Total Polls: ", $.polls);
    });
    $.$root.$on("showPollToClients", (data) => {
      // console.log("Poll data: ", data);
      this.clientPoll.question = data.question;
      this.clientPoll.answers = data.answers;
      this.clientPoll.poll_id = data.poll_id;

      this.visibleResults = false;
      // console.log("ClientPoll Data: ", this.clientPoll);
      this.showClientPoll();
    });
    $.$root.$on("emojiCountIncrease", (data) => {
      $.reaction = data;
    });
    $.$root.$on("hostIsHidden", (data) => {
      console.log("Hidden Host: ", data);
      $.hiddenUid = data.id;
      $.$store.state.isHostHidden = true;
      if ($.$store.state.isHostHidden) {
        $.handleHideHost();
      } else {
        $.handleUnhideHost();
      }
    });
    $.$root.$on("hostIsUnhidden", () => {
      console.log("Unhidden host id: ");
      $.$store.state.isHostHidden = false;
      $.handleUnhideHost();
    });
    $.$root.$on("handlesubmitSetting", (packet) => {
      console.log(" video call packet: ", packet);
      if (!this.localStream.isPlaying()) {
        this.localStream.play();
      }
      packet.req.forEach((item) => {
        if (
          item.type === "video" &&
          item.deviceId !== this.$store.state.cameraId
        ) {
          $.localStream.switchDevice(
            `video`,
            `${item.deviceId}`,
            function() {
              $.$toast.open({
                message: "Device switch success",
                type: "success",
                position: "top",
                queue: true,
              });
            },
            function(err) {
              console.log(err);
            }
          );
          this.$store.state.cameraId = item.deviceId;
        }
        if (
          item.type === "audio" &&
          item.deviceId !== this.$store.state.microphoneId
        ) {
          $.localStream.switchDevice(
            `audio`,
            `${item.deviceId}`,
            function() {
              $.$toast.open({
                message: "Device switch success",
                type: "success",
                position: "top",
                queue: true,
              });
            },
            function(err) {
              console.log(err);
            }
          );
          this.$store.state.microphoneId = item.deviceId;
        }
      });
    });
    $.$root.$on("clientPleaseIncreaseYourStreamCount", () => {
      console.log(
        "%c:Got the message to increase stream count-",
        "background: #ff00dd; color: #00ff00"
      );
      // this.$store.state.streamCount += 1;
    });
    $.$root.$on("clientScreenShareHasStarted", (uid) => {
      console.log(uid);
      // making isScreenShare true on client side
      $.isScreenShare = true;
      $.isScreenBeingSharedByRemote = true;
    });
    $.$root.$on("clientScreenShareHasStopped", (uid) => {
      console.log(uid);
      // making isScreenShare false on client side
      $.isScreenBeingSharedByRemote = false;
      // $.displayMode = "tile";
      $.canvasLayout();
      // $.readyVideoView(uid);
    });
    $.$root.$on("clientpleaseemptylocalstream", () => {
      // unpublish your stream if you are publishing
      if ($.localStream !== undefined) {
        // Stop playing the local stream
        // $.localStream.stop();
        // Close the local stream
        $.localStream.close();
        $.client.unpublish($.localStream);
        $.removeStream($.uid);
        $.isControl = false;
      }
      $.streamList.length = 0;
      $.$store.state.streamCount = 0;
    });
    $.$root.$on("pleaseDeleteYourLocalStream", (uid) => {
      if ($.streamList.length > 0) {
        if (uid == $.uid) {
          console.log(uid);
          $.$store.state.showScreenShareButtonForOthers = false;
          $.client.unpublish($.localStream);
          $.removeStream($.uid);
          $.isControl = false;
        }
      }
      if ($.handRequest.length > 0) {
        $.handRequest.forEach((item, i) => {
          if (item == uid) {
            $.handRequest.splice(i, 1);
          }
        });
      }
    });
    $.$root.$on("playvideoforuser", (uid) => {
      const $ = this;
      console.log("hand raise uid: ", uid);
      let playFlag = false;
      if ($.uid == uid) {
        playFlag = true;
      }
      if (playFlag) {
        $.localStream = this.streamInit(
          $.uid,
          "host",
          $.videoProfile,
          $.config
        );
        $.localStream.init(
          () => {
            // $.addCanvas();
            // Find the canvas element to capture
            // var canvasElt = document.querySelector("#canvaslocal");

            // Get the stream
            // var stream = canvasElt.captureStream(15); // 25 FPS
            // Replace track
            // console.log(`stream canvas: ${stream}`);
            // $.localStream.replaceTrack(
            //   stream.getVideoTracks()[0],
            //   () => {
            //     console.log("successfully replaced");
            //   },
            //   (err) => {
            //     console.log(`error replacing: ${err}`);
            //   }
            // );
            $.addStream($.localStream, true);
            $.client.publish($.localStream, (err) => {
              console.log("Publish local stream error: " + err);
            });
            jquery(window).on("beforeunload", function() {
              return "Are you sure you want to leave?";
            });
            $.showControls();
            $.startLiveTranscoding();
            $.$store.state.showScreenShareButtonForOthers = true;
            $.isHandRaised = false;
            $.readyState = true;
            // $.$root.$emit("submitSetting");
          },
          (err) => {
            console.log("getUserMedia failed", err);
            $.readyState = true;
          }
        );
      }
    });
    $.$root.$on("sendingBackIdForHandraise", (uid, payload) => {
      console.log(uid, "user device info: ", payload);
      if ($.handRequest !== undefined && $.handRequest.length === 0) {
        $.handRequest.push(uid);
      } else if ($.handRequest !== undefined && $.handRequest.length > 0) {
        const pushFlag = $.handRequest.includes(uid);
        if (!pushFlag) {
          $.handRequest.push(uid);
        }
      }
    });
    $.$root.$on("withdrawRequest", (data) => {
      if ($.handRequest.length > 0) {
        $.handRequest.forEach((item, i) => {
          if (item == data) {
            $.handRequest.splice(i, 1);
          }
        });
      }
    });
    $.$root.$on("deletethisuserfromhandrequestarray", () => {
      if ($.handRequest.length > 0) {
        $.handRequest.shift();
        $.getHandRaiseStatus();
      }
    });
    $.$root.$on("exit", () => {
      // this.$store.state.isLive = false;
      $.handleExit();
    });
    $.$root.$on("removeVideoLayoutChange_1", (uid) => {
      $.canvasLayout();
      this.handRequest.map((item, index) => {
        if (item == uid) {
          this.handRequest.splice(index, 1);
        }
      });
      // $.$store.state.showScreenShareButtonForOthers = true;
    });
    $.$root.$on("handleLeaveListener", (uid) => {
      // console.log("Streamsss: ", this.$store.state.streamCount);

      $.handleLeave(uid);
      $.isHandRaised = false;
    });
    $.$root.$on("stopScreenShare", (uid) => {
      if (uid === $.uid) {
        $.handleStopScreenShare();
      }
    });
    this.$root.$on("sendingHostResponse", (bool, userData) => {
      let dd = { accept: false, decline: true };
      if (bool) {
        dd = { accept: true, decline: false };
      }
      // console.log("sendingHostResponse: ", userData);
      this.handleHostResponse(dd, userData);
    });
    this.$root.$on("showReaction", (emojiId) => {
      // this.flagContainer.reactionFlag = true;
      this.showReactionAnimation(emojiId);
    });
    this.$root.$on("hideReaction", () => {
      this.flagContainer.reactionFlag = false;
    });
    $.$root.$on("clientBreakIsOn", () => {
      $.$store.state.isLive = false;
      $.$store.state.isScreenShare = false;
      this.client.unpublish(this.localStream);
      this.client.leave(
        () => {
          console.log("Client succeed to leave.");
        },
        () => {
          console.log("Client failed to leave.");
        }
      );
      if ($.streamList.length > 0) {
        $.streamList.forEach((stream) => {
          let obj = document.querySelector("#ag-item-" + stream.getId());
          obj.remove();
        });
      }
    });
    introJS
      .introJs()
      .setOptions({
        hints: [
          {
            element: document.querySelector("#handRaiseBtn"),
            hint:
              "Audience can join the video call, all you need to do is accept hand raise",
            hintPosition: "left",
          },
        ],
      })
      .addHints();
  },
  updated() {},
  beforeUpdate() {
    let $ = this;

    console.log(
      "beforeUpdate: ",
      $.streamList.length,
      "display mode: ",
      $.displayMode
    );
    let da = {
      channel_id: $.$route.params.session,
    };
    $.$store.dispatch("getEventMembersData", da).then((resp) => {
      if (resp.data.status === "success") {
        $.$store.memberList = resp.data.data;
      }
    });
  },
  beforeDestroy() {
    const $ = this;
    // $.stopCamera();
    if ($.attendeeMode === "host" && $.attendeeMode === "speaker") {
      $.$root.$emit("pleaseemptylocalstream");
    }
    if ($.isActiveScreenShare) {
      $.isActiveScreenShare = false;
      $.$store.state.isScreenShare = false;
      $.isScreenBeingSharedByRemote = false;
      $.$root.$emit("clientScreenShareStopped");
      $.screenShareClient &&
        this.screenShareClient.unpublish(this.screenShareStream);
      $.screenShareStream && this.screenShareStream.close();
      $.screenShareClient &&
        $.screenShareClient.leave(
          () => {
            console.log("Screen Client succeed to leave.");
          },
          () => {
            console.log("Screen Client failed to leave.");
          }
        );
    }
    $.client && this.client.unpublish(this.localStream);
    $.localStream && this.localStream.close();
    $.client &&
      $.client.leave(
        () => {
          console.log("Client succeed to leave.");
        },
        () => {
          console.log("Client failed to leave.");
        }
      );
  },
};
</script>

<style lang="scss">
.tooltip {
  position: relative;
  z-index: 100000;
  opacity: 1;
  // display: inline-block;
  // border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #1f1f1f;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 150%;
  left: 50%;
  margin-left: -60px;
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: black transparent transparent transparent;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
  font-size: 14px;
}
.btn-session {
  font-size: 14px !important;
  border-radius: 25px !important;
  @media only screen and (max-width: 1200px) {
    font-size: 12px !important;
  }
}
.meeting-stage {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}
.table-structure {
  background: url("../../assets/kuchi-table.png");
  background-size: cover;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  right: 0;
  filter: blur(6px);
  -webkit-filter: blur(6px);
}
#ag-canvas {
  height: 100%;
  display: flex;
  overflow: none;
  // grid-gap: 5px;
  // align-items: center;
  // justify-items: center;
  // grid-template-rows: repeat(12, auto);
  // grid-template-columns: repeat(24, auto);
  transition: flex 0.2s;
}
#screen-share-panel {
  display: flex;
  flex-wrap: wrap;
  // transition: flex .3s ease-out;
}
$c_container: #2980b9;
$c_emotes_container: #3498db;
$size_container: 60px;
$wave_duration: 4s;
@keyframes waveY {
  from {
    transform: translate3D(0, 100%, 0);
  }
  to {
    transform: translate3D(0, 0%, 0);
  }
}
@keyframes scaleOut {
  60% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes emoji {
  0% {
    transform: translateY(-10px);
    // transform: scale(1);
  }
  10% {
    transform: scale(0.85);
  }
  100% {
    transform: translateY(-350px);
  }
}
#container-reaction {
  z-index: 100;
}
.reaction-list {
  margin: 0;
  padding: 0;
  position: absolute;
  right: 0px;
  top: -60px;
  visibility: hidden;
  display: flex;
  justify-content: space-evenly;
  width: 240px;
  height: 65px;
  border-radius: 8px;
  background-color: #1b1b1b;
  border: 1px solid #979797;
  transition: 1s all ease;
}
.reactBtn {
  border: 1px solid #fff;
}
.reaction-list li {
  list-style: none;
  margin-top: -3px;
}
.reaction-list li button {
  border: none;
  background: transparent;
  cursor: pointer;
  outline: 0;
  font-size: 30px;
  // margin-top: 8px;
}
.reaction-list li button img {
  width: 35px;
}
.reaction-list li button span {
  font-size: 12px;
  color: #fff;
  font-weight: bold;
  display: block;
}
.reaction-bar:hover .reaction-list {
  visibility: visible;
}
.emojiCount {
  font-size: 13px;
  color: #fff;
}
.reaction-list-2 {
  margin: 0;
  padding: 0;
  position: absolute;
  right: 0px;
  top: -107px;
  visibility: hidden;
  display: flex;
  justify-content: space-evenly;
  width: 271px;
  height: 64px;
  border-radius: 8px;
  background-color: #1b1b1b;
  border: 1px solid #979797;
  transition: 1s all ease;
}
.reactBtn {
  border: 1px solid #fff;
}
.reaction-list-2 li {
  list-style: none;
}
.reaction-list-2 li button {
  border: none;
  background: transparent;
  cursor: pointer;
  outline: 0;
  font-size: 40px;
  // margin-top: 8px;
}
.reaction-bar:hover .reaction-list-2 {
  visibility: visible;
}
#showEmoji {
  position: absolute;
  width: 50px;
  right: 20px;
  // border: 1px solid black;
  bottom: -100px;
  opacity: 0;
}
.audio-indicator {
  border-radius: 2px;
  max-height: 1.5rem;
  height: 0.15rem;
  width: 4px;
  background-color: #ffb229;
  transition: 0.2s ease all;
  margin-left: 5px;
}
/*
.live-emotes {
  position: absolute;
  bottom: 12%;
  right: 10%;
  z-index: 100;
  height: $size_container;
  margin: auto;
  .live-emote-container {
    position: absolute;
    right: -$size_container;
    top: -50%;
    user-select: none;
    animation: waveY 3s infinite;
    animation-direction: alternate;
    .live-emote {
      width: 100%;
      height: 100%;
      &-content {
        width: 100%;
        height: 100%;
        img {
          width: 50%;
        }
      }
    }
  }
  .live-emote-container:nth-child(1) {
    animation-duration: 1s;
    animation-timing-function: cubic-bezier(0.76, 0.2, 0.47, 0.85);
    .live-emote {
      animation-duration: 11s;
      animation-timing-function: cubic-bezier(0.76, 0.2, 0.47, 0.85);
      &-content {
        animation-duration: 11s;
      }
    }
  }
}
*/
.ag-item :first-child {
  border-radius: 6px;
}
.ag-item {
  border-radius: 6px;
  /*border: 2px #fbaf28 solid;*/
  box-shadow: 0px 0px 2px #000;
  /* background: url("../assets/images/avatar.png") center no-repeat; */
  height: 100%;
  width: 100%;
  /*transition: all 1s;*/
}
#ag-resize-container {
  background-image: none !important;
  background-color: black;
  display: flex;
  justify-content: center;
  height: center;
}
#ag-resize-container .ag-item {
  border: none !important;
}
/* button group */
.ag-btn-group {
  width: 100%;
  margin: 0 auto;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 11;
  display: flex;
  background-image: linear-gradient(transparent, #000);
  justify-content: space-between;
  align-items: center;
}
/*.ag-btn-group:hover,*/
/*.ag-btn-group.active {*/
/* background: rgba(0, 0, 0, 0.88);*/
/*}*/
.ag-btn {
  z-index: 12;
  /*opacity: 0;*/
  color: #feb22a;
  height: 45px;
  cursor: pointer;
  font-size: 20px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: #1b1b1b;
  padding: 10px 15px;
  border: 1px solid #feb22a;
  border-radius: 12px;
  margin: 5px;
}
.ag-btn:hover {
  color: #fbaf28;
}
.ag-btn.disabled,
.ag-btn.disabled:hover {
  color: rgba(76, 76, 76, 0.99);
  cursor: not-allowed;
}
.ag-btn-group:hover .ag-btn,
.ag-btn-group.active .ag-btn {
  opacity: 1;
}
.ag-btn.off.videoControlBtn .fa-video {
  display: none;
}
.ag-btn.videoControlBtn .fa-video-slash {
  display: none;
}
.ag-btn.videoControlBtn .fa-video {
  display: inline-block;
}
.ag-btn.off.videoControlBtn .fa-video-slash {
  display: inline-block;
}
.ag-btn.off.audioControlBtn .fa-microphone {
  display: none;
}
.ag-btn.audioControlBtn .fa-microphone-slash {
  display: none;
}
.ag-btn.audioControlBtn .fa-microphone {
  display: inline-block;
}
.ag-btn.off.audioControlBtn .fa-microphone-slash {
  display: inline-block;
}
// If recording has started show this button
.ag-btn.off.recordingControlBtn .fa-stop {
  display: inline-block;
  // display: none;
}
// If recording has not started/paused show this button
.ag-btn.recordingControlBtn .fa-play {
  display: inline-block;
  // display: none;
}
.ag-btn.recordingControlBtn .fa-stop {
  display: none;
}
.ag-btn.off.recordingControlBtn .fa-play {
  display: none;
}
video {
  max-width: unset !important;
}
.main-div {
  display: inline;
  margin-top: 10px;
  padding: 0px;
  margin-bottom: 0;
  .audio-icon-div {
    margin-left: 8px;
  }
  .video-icon-div {
    margin-left: 8px;
  }
}
.display-none {
  display: none !important;
}
.disabled {
  color: rgba(76, 76, 76, 0.99);
  cursor: not-allowed;
}
.grid-test {
  grid-area: span 12 / span 12/13/13 !important;
}
.display-block {
  display: block !important;
  video {
    position: absolute !important;
  }
}
.display-screen {
  grid-area: span 12 / span 24/13/25;
  //grid-area: span 12 / span 24;
  border-radius: 6px;
  /*border: 2px #fbaf28 solid;*/
  box-shadow: 0px 0px 2px #000;
  /* background: url("../assets/images/avatar.png") center no-repeat; */
  height: 100%;
  width: 100%;
}
#offline {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 6px;
  z-index: 100;
  background: rgba(10, 10, 10, 0.75);
  padding: 5%;
  font-size: 1.5rem;
}
.video-info {
  z-index: 1;
  border-radius: 0 5px 5px 0;
}
#clientPoll {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(10, 10, 10, 0.75);
}
.vue-poll {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}
.vue-poll .noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.vue-poll .qst {
  font-weight: normal;
}
.vue-poll .row {
  padding-left: 0.6em;
  padding-top: 0.6em;
}
.vue-poll .ans-cnt {
  margin: 20px 0;
  width: 95%;
  padding-left: 0.6em;
}
.vue-poll .ans-cnt .ans {
  position: relative;
  margin-top: 10px;
}
.vue-poll .ans-cnt .ans:first-child {
  margin-top: 0;
}
.vue-poll .ans-cnt .ans-no-vote {
  text-align: center;
  border: 2px solid #77c7f7;
  box-sizing: border-box;
  border-radius: 5px;
  cursor: pointer;
  padding: 5px 0;
  transition: background 0.2s ease-in-out;
  -webkit-transition: background 0.2s ease-in-out;
  -moz-transition: background 0.2s ease-in-out;
}
.vue-poll .ans-cnt .ans-no-vote .txt {
  color: #77c7f7;
  transition: color 0.2s ease-in-out;
  -webkit-transition: color 0.2s ease-in-out;
  -moz-transition: color 0.2s ease-in-out;
}
.vue-poll .ans-cnt .ans-no-vote.active {
  background: #77c7f7;
}
.vue-poll .ans-cnt .ans-no-vote.active .txt {
  color: #fff;
}
.vue-poll .ans-cnt .ans-voted {
  padding: 5px 0;
}
.vue-poll .ans-cnt .ans-voted .percent,
.vue-poll .ans-cnt .ans-voted .txt {
  position: relative;
  z-index: 1;
}
.vue-poll .ans-cnt .ans-voted .percent {
  font-weight: bold;
  min-width: 51px;
  display: inline-block;
  margin: 0 10px;
}
.vue-poll .ans-cnt .ans-voted.selected .txt:after {
  content: "✔";
  margin-left: 10px;
}
.vue-poll .ans-cnt .ans .bg {
  position: absolute;
  width: 0%;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 0;
  background-color: #e1e8ed;
  border-radius: 5px;
  transition: all 0.3s cubic-bezier(0.5, 1.2, 0.5, 1.2);
  -webkit-transition: all 0.3s cubic-bezier(0.5, 1.2, 0.5, 1.2);
  -moz-transition: all 0.3s cubic-bezier(0.5, 1.2, 0.5, 1.2);
}
.vue-poll .ans-cnt .ans .bg0 {
  position: absolute;
  width: 0%;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 0;
  background-color: rgb(224, 109, 109);
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  transition: all 0.3s cubic-bezier(0.5, 1.2, 0.5, 1.2);
  -webkit-transition: all 0.3s cubic-bezier(0.5, 1.2, 0.5, 1.2);
  -moz-transition: all 0.3s cubic-bezier(0.5, 1.2, 0.5, 1.2);
}
.vue-poll .ans-cnt .ans .bg.selected {
  background-color: #77c7f7;
}
.vue-poll .votes {
  font-size: 14px;
  color: #8899a6;
}
.vue-poll .submit {
  display: block;
  text-align: center;
  margin: 0 auto;
  max-width: 80px;
  text-decoration: none;
  background-color: #41b882;
  color: #fff;
  padding: 10px 25px;
  border-radius: 5px;
}
.hostPolls {
  overflow-y: initial !important;
}
.hostPolls .modal-body {
  height: 250px;
  overflow-y: auto;
}
#liveRecordingTimer {
  display: none;
}
.blink {
  color: red;
  background: red;
  border-radius: 35px;
  height: 1em;
  margin: 3px 10px;
  animation: blinking 1s infinite alternate;
}
.Rectangle {
  width: 45px;
  height: 45px;
  margin-top: 5px;
  margin-right: 5px;
  border-radius: 12px;
  border: solid 1px #ffb229;
  color: #ffb229;
  background-color: transparent;
  font-weight: bold;
}

.btn-group .dropdown-menu::before {
  content: none !important;
}

.btn-group .dropdown-menu {
  background-color: #1b1b1b;
  border: 1px solid rgb(161, 160, 160);
  border-radius: 12px;
}

.btn-group .dropdown-menu .dropdown-item {
  color: #ffe;
}

.btn-group .dropdown-menu .dropdown-item:hover {
  background-color: #ffb229;
  color: #1b1b1b;
}

@keyframes blinking {
  from {
    box-shadow: 0px 0px 10px red;
  }
  to {
    box-shadow: 0px 0px 0px red;
  }
}

.screenShare-presenting {
  transform: translate(-64%, -50%);
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 10;
  background: #000;
  width: 97vw;
  height: 100%;
  text-align: center;
  justify-content: center;
  align-items: flex-start;
}
.presenting-heading {
  position: absolute;
  top: 45%;
  z-index: 111;
  left: 55%;
  /* transform: translate(-50%, -50%); */
}
</style>
